import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { proposallistData } from "../../../core/data/json/proposallist";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
  activeList,
  clientList,
  currency,
  dealsselectOption,
  editreleatdselectOption,
  initialSettings,
  newselectOption,
  owner,
  priorityList,
  releatdselectOption,
} from "../../../core/common/selectoption/selectoption";
import CollapseHeader from "../../../core/common/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  setActivityTogglePopup,
  setActivityTogglePopupTwo,
} from "../../../core/data/redux/commonSlice";
import DatePicker from "react-datepicker";
import { TagsInput } from "react-tag-input-component";
import DefaultEditor from "react-simple-wysiwyg";
import { all_routes } from "../../router/all_routes";
import Proposalsgrid from "./proposalsgrid";
import { fetchAllLeads, getLeadsByUserId, Lead } from "../../../api/lead";
import {
  fetchAllProposals,
  ProposalResponse,
  createProposal,
  deleteProposal,
  fetchProposalById,
  updateProposal,
  fetchProposalsByUserId,
  fetchProposalWithHistory,
  ProposalWithHistoryResponse,
  updateProposalRevision,
  deleteProposalsBulk,
} from "../../../api/proposal";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { highlightMatch } from "../../../core/common/highlightmatch";
import { RootState } from "../../../core/data/redux/store";
import { Avatar, TableProps,Menu,Dropdown,Button,Checkbox } from "antd";
import { DownOutlined,FunnelPlotFilled,BarsOutlined,EditOutlined,CheckCircleTwoTone,CloseCircleTwoTone } from '@ant-design/icons';
import PageLoadProgressBar from "../../../core/data/json/pageLoadProgressBar";
import { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import CountUp from "react-countup";
import AnimatedBadge from "../../../core/common/AnimatedBadge/index";
import SequentialHighlight from "../../../core/common/SequentialHighlight";

import ColumnManagement from "../../../core/common/ColumnManagement";
import ScrollToTop from "../../../core/common/ScrollToTop";
import ModalDeleteEffect from "../../../core/common/ModalDeleteEffect";
import SubmoduleHoverCard from "../../../core/common/SubCard2Button";
import TextCopy2 from "../../../core/common/textcopy2";
import ProposalDetailsModal from "../../../core/common/ProposalDetailsModal";
import { useColumnOrderSave } from "../../../core/common/useColumnOrderSave";
import { FaDownload, FaEnvelope } from "react-icons/fa";
// Define the extended props
interface ExtendedTableProps<T> extends TableProps<T> {
  expandable?: {
    expandedRowKeys?: string[];
    onExpand?: (expanded: boolean, record: T) => void;
    expandedRowRender?: (record: T) => ReactNode;
  };
}

type ColumnKey =
  | "SI_no"
  | "contact_name"
  | "lead_owner"
  | "quotaiton_id"
  | "revision_id"
  | "proposal_amount"
  | "sub_total"
  | "cgst"
  | "sgst"
  | "igst"
  | "proposal_total_amount"
  | "signature_name"
  | "Date_of_proposal"
  | "validation_date"
  | "product_name"
  | "created_at"
  | "status"
  | "history"
  | "action";

interface ColumnConfig {
  title: React.ReactNode;
  key: ColumnKey;
  dataIndex?: string;
  sorter?: boolean | ((a: ProposalResponse, b: ProposalResponse) => number);
  render?: (
    value: any,
    record: ProposalResponse,
    index?: number
  ) => React.ReactNode;
  fixed?: "left" | "right";
  width?: number;
}


const defaultVisibleColumns = {
  // index: true, (Sticky SI_no)
  SI_no: true,
  contact_name: true,
    quotaiton_id: true,
    lead_owner: true,
    revision_id: true, 
    sub_total: true,
    proposal_amount: true,
    cgst: true,
    sgst: true,
    igst: true,
    proposal_total_amount: true,
    signature_name: true,
    Date_of_proposal: true,
    validation_date: true,
    product_name: true,
    created_at: true,
    status: true,
    history: true,
    action: true,
};

const defaultColumnOrder = [
  "SI_no",
  "contact_name",
  "quotaiton_id",
  "lead_owner",
  "revision_id",
  "sub_total",
  "proposal_amount",
  "cgst",
  "sgst",
  "igst",
  "proposal_total_amount",
  "signature_name",
  "Date_of_proposal",
  "validation_date",
  "product_name",
  "created_at",
  "status",
  "history",
  "action",
];

const columnLabels = {
  SI_no: "SI_no",
  contact_name: "Client",
  lead_owner: "Lead Owner",
  quotaiton_id: "Quotation ID",
  revision_id: "Revision ID",
  proposal_amount: "Quoted Value",
  sub_total: "Subtotal",
  cgst: "cgst",
  sgst: "sgst",
  igst: "igst",
  proposal_total_amount: "Total Amount",
  signature_name: "Signature Name",
  Date_of_proposal: "Date of Proposal",
  validation_date: "Validation Date",
  product_name: "Product Name",
  created_at: "Created At",
  status: "Status",
  history: "History",
  action: "Action",
};

const Proposalslist = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const [leads, setLeads] = useState<Lead[]>([]);
  const [selectedLeadId, setSelectedLeadId] = useState<string>("");
  const [selectedProposalId, setSelectedProposalId] = useState<string | null>(
    null
  );
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectedProposalForModal, setSelectedProposalForModal] = useState<ProposalResponse | null>(null);
  const [invoiceData, setInvoiceData] = useState<ProposalResponse | null>(null);
  const [orderedData, setOrderedData] = useState<ProposalResponse[]>([]);
  const [selectedAssigned, setSelectedAssigned] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [expandedRows, setExpandedRows] = useState<string[]>([]);
  const defaultDescription = `  
1. Payment Terms: Payment at the time of order.
2. Cheque should be drawn in favor of EROYAL TECH SYSTEMS PRIVATE LIMITED.
3. Taxes: All the tax are applicable as per Government rule.
4. AMC, Per Login Rs. 8000/- + Gst. Second Year Onwards.
5. If Required Tally Integration for Accounts Charges Rs.10000/- + Gst.
  `.trim();

  const [formData, setFormData] = useState({
    lead_id: "",
    contact_person: "",
    Currency: "",
    product: "",
    company_name: "",
    company_phone: "",
    signature_name: "",
    description: defaultDescription,
    status: "",
    cgst: 0,
    sgst: 0,
    igst: 0,
    proposal_no_logins: 1,
    proposal_rate_per_login: 0,
    proposal_discount: 0,
    discount_amount: 0,
    proposal_amount: 0,
    proposal_total_amount: 0,
    cgst_percentage: 0,
    sgst_percentage: 0,
    igst_percentage: 0,
    proposal_discount_percentage: 0,
    sub_total: 0,
    lead_owner_name: "",
    lead_owner_email: "",
    lead_owner_phone: "",
  });
  const proposalRef = useRef<HTMLDivElement>(null);
  const [proposals, setProposals] = useState<ProposalResponse[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [signatureFile, setSignatureFile] = useState<File | null>(null);
  const [items, setItems] = useState([
    {
      item: "",
      quantity: 1,
      price: 0,
      proposal_discount_percentage: 0,
      discount_amount: 0,
      discount_type: "percentage",
      cgst_percentage: 0,
      sgst_percentage: 0,
      igst_percentage: 0,
      subtotal: 0,
      proposal_amount: 0,
    },
  ]);
const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const [searchText, setSearchText] = useState("");
  const [sortOption, setSortOption] = useState("recently_added");
  const [dateRange, setDateRange] = useState<[Date, Date]>([
    initialSettings.startDate,
    initialSettings.endDate,
  ]);
  const [visibleColumns, setVisibleColumns] = useState<Record<string, boolean>>(
    defaultVisibleColumns
  );
  const [filters, setFilters] = useState({
    proposal_id: "",
    revision_id: "",
    contact_name: "",
    product_name: "",
    status: [] as string[],
    Date_of_proposal: [] as string[],
    validation_date: [] as string[],
    created_at: [] as string[],
    client: "",
    quoted_min: "",
    quoted_max: "",
  });
  const statusOptions = ["Draft", "Accepted", "Declined"];
  const activeStatusFilter =
    filters.status.length === 1 ? filters.status[0] : "All";
const [clientSearch, setClientSearch] = useState("");
const [productSearch, setProductSearch] = useState("");
const [statusSearch, setStatusSearch] = useState("");
  // Memoize proposals fetch to avoid redundant calls
  const fetchProposalsMemo = useMemo(() => fetchProposalsByUserId, []);
  const fetchLeadsMemo = useMemo(() => getLeadsByUserId, []);
   const [alphaFilterleadowner, setAlphaFilterleadowner] = useState<string>("All");
  const [alphaFilterproduct, setAlphaFilterproduct] = useState<string>("All");
  const userId = useSelector((state: RootState) => state.auth.user_id);
  const [alphaFilter, setAlphaFilter] = useState<string>("All");
  const [selectedProposals, setSelectedProposals] = useState<string[]>([]);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [filterProducts, setFilterProducts] = useState<string[]>([]);
const [filterStatus, setFilterStatus] = useState<string[]>([]);
const [filterQuotationIds, setFilterQuotationIds] = useState<string[]>([]);
const [filterRevisionIds, setFilterRevisionIds] = useState<string[]>([]);
const [filterContactNames, setFilterContactNames] = useState<string[]>([]);
const [filterProductNames, setFilterProductNames] = useState<string[]>([]);
const [filterClients, setFilterClients] = useState<string[]>([]);
const [filterQuotedValues, setFilterQuotedValues] = useState<string[]>([]);
const [filterQuoteStatuses, setFilterQuoteStatuses] = useState<string[]>([]);
const [filterQuoteDates, setFilterQuoteDates] = useState<string[]>([]);
const [filterValidationDates, setFilterValidationDates] = useState<string[]>([]);
const [createdAtFilter, setCreatedAtFilter] = useState<string[]>([]);
const [createdAtSearch, setCreatedAtSearch] = useState("");
const [filterOwners, setFilterOwners] = useState<string[]>([]);
const [ownerSearch, setOwnerSearch] = useState("");
  const [filterProposalIds, setFilterProposalIds] = useState<string[]>([]);
  const [proposalIdSearch, setProposalIdSearch] = useState("");

  const [revisionIdSearch, setRevisionIdSearch] = useState("");


  const [productNameSearch, setProductNameSearch] = useState("");
  const [filterStatuses, setFilterStatuses] = useState<string[]>([]);

  const [filterProposalDates, setFilterProposalDates] = useState<string[]>([]);
  const [proposalDateSearch, setProposalDateSearch] = useState("");
  
  const [validationDateSearch, setValidationDateSearch] = useState("");
  const [filterCreatedAts, setFilterCreatedAts] = useState<string[]>([]);

  const [isDeleting, setIsDeleting] = useState(false);
  const userRole = useSelector((state: RootState) => state.auth.role);
  const refreshProposals = useCallback(async () => {
    try {
      if (userId) {
        setLoading(true);
        const updatedProposals = await fetchProposalsMemo(userId);
        setProposals(updatedProposals);
        setOrderedData(updatedProposals);
      }
    } catch (err) {
      toast.error("Failed to refresh proposals.");
      console.error("Refresh error:", err);
    } finally {
      setLoading(false);
    }
  }, [userId, fetchProposalsMemo]);

  useEffect(() => {
    refreshProposals();
  }, [refreshProposals]);

  useEffect(() => {
    const fetchUserLeads = async () => {
      try {
        if (userId) {
          const data = await fetchLeadsMemo(userId);
          setLeads(data);
        }
      } catch (err) {
        console.error("Failed to fetch user-specific leads");
      }
    };
    fetchUserLeads();
  }, [userId, fetchLeadsMemo]);

  // Memoize leads options for Select to avoid recreation
  const leadsOptions = useMemo(
    () =>
      [...leads].reverse().map((lead) => ({
        value: lead.lead_id,
        label: `${lead.contact?.company_name || "Unknown Company"} (${
          lead.contact?.contact_person_name || "Unknown Contact"
        })`,
      })),
    [leads]
  );

  useEffect(() => {
    const styleId = "animated-badge-keyframes";
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.innerText = `
        @keyframes shine {
          0% {
            transform: skewX(-20deg) translateX(-150%);
          }
          50% {
             transform: skewX(-20deg) translateX(150%);
          }
          100% {
            transform: skewX(-20deg) translateX(150%);
          }
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  useEffect(() => {
    const makeModalDraggable = (modalId: string) => {
      const modalElement = document.getElementById(modalId);
      if (!modalElement) return;

      const modalDialog = modalElement.querySelector(
        ".modal-dialog"
      ) as HTMLElement;
      const modalHeader = modalElement.querySelector(
        ".modal-header"
      ) as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let currentX = 0;
      let currentY = 0;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      const resetPosition = () => {
        currentX = 0;
        currentY = 0;
        initialX = 0;
        initialY = 0;
        startX = 0;
        startY = 0;
        isDragging = false;

        modalDialog.style.position = "";
        modalDialog.style.top = "";
        modalDialog.style.left = "";
        modalDialog.style.transform = "";
        modalDialog.style.margin = "";
        modalDialog.style.transition = "";
        modalDialog.style.width = "";
        modalDialog.style.maxWidth = "";

        if (!modalDialog.classList.contains("modal-dialog-centered")) {
          modalDialog.classList.add("modal-dialog-centered");
        }
      };

      const handleShow = () => {
        resetPosition();
      };

      const handleShown = () => {
        resetPosition();
      };

      const handleHidden = () => {
        resetPosition();
      };

      modalElement.addEventListener("show.bs.modal", handleShow);
      modalElement.addEventListener("shown.bs.modal", handleShown);
      modalElement.addEventListener("hidden.bs.modal", handleHidden);

      const dragStart = (e: MouseEvent) => {
        // Only allow dragging from header, not from close button or other interactive elements
        const target = e.target as HTMLElement;
        if (
          target.closest(".btn-close") ||
          target.closest("button") ||
          target.closest("input") ||
          target.closest("select")
        ) {
          return;
        }

        if (
          e.target === modalHeader ||
          modalHeader.contains(e.target as Node)
        ) {
          isDragging = true;
          modalHeader.style.cursor = "move";

          // Get current position and size of modal dialog
          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          // Get computed styles to preserve the modal's size
          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          // Remove centered class to allow free movement
          modalDialog.classList.remove("modal-dialog-centered");

          // Set initial position based on current position
          modalDialog.style.position = "fixed";
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = "0";
          modalDialog.style.transform = "none";
          modalDialog.style.transition = "none";

          // Preserve the modal's width and max-width to prevent size change
          if (
            currentWidth &&
            currentWidth !== "auto" &&
            currentWidth !== "0px"
          ) {
            modalDialog.style.width = currentWidth;
          }
          if (
            currentMaxWidth &&
            currentMaxWidth !== "none" &&
            currentMaxWidth !== "0px"
          ) {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (
            currentMinWidth &&
            currentMinWidth !== "0px" &&
            currentMinWidth !== "auto"
          ) {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;

        e.preventDefault();

        // Calculate new position
        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        // Get modal dialog dimensions
        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        // Constrain to viewport
        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        // Update position
        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;

        // Store current position for next drag
        currentX = constrainedX;
        currentY = constrainedY;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = "move";
          modalDialog.style.transition = "";
          // Keep the fixed positioning during drag, but allow reset on next open
        }
      };

      // Add cursor style to header
      modalHeader.style.cursor = "move";
      modalHeader.style.userSelect = "none";

      // Event listeners
      modalHeader.addEventListener("mousedown", dragStart);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", dragEnd);

      // Cleanup function
      return () => {
        modalElement.removeEventListener("show.bs.modal", handleShow);
        modalElement.removeEventListener("shown.bs.modal", handleShown);
        modalElement.removeEventListener("hidden.bs.modal", handleHidden);
        modalHeader.removeEventListener("mousedown", dragStart);
        document.removeEventListener("mousemove", drag);
        document.removeEventListener("mouseup", dragEnd);
      };
    };

    const cleanup = makeModalDraggable("delete_proposals");

    return () => {
      cleanup?.();
    };
  }, []);

  useEffect(() => {
    const setupModalDraggable = (modalElement: HTMLElement) => {
      if (modalElement.hasAttribute('data-draggable-setup')) return;
      modalElement.setAttribute('data-draggable-setup', 'true');

      const modalDialog = modalElement.querySelector('.modal-dialog') as HTMLElement;
      const modalHeader = modalElement.querySelector('.modal-header') as HTMLElement;

      if (!modalDialog || !modalHeader) return;

      let isDragging = false;
      let initialX = 0;
      let initialY = 0;
      let startX = 0;
      let startY = 0;

      const resetPosition = () => {
        isDragging = false;
        modalDialog.style.position = '';
        modalDialog.style.top = '';
        modalDialog.style.left = '';
        modalDialog.style.transform = '';
        modalDialog.style.margin = '';
        modalDialog.style.transition = '';
        modalDialog.style.width = '';
        modalDialog.style.maxWidth = '';

        if (!modalDialog.classList.contains('modal-dialog-centered')) {
          modalDialog.classList.add('modal-dialog-centered');
        }
      };

      const dragStart = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (target.closest('.btn-close') || target.closest('button') || target.closest('input') || target.closest('select')) {
          return;
        }

        if (e.target === modalHeader || modalHeader.contains(e.target as Node)) {
          isDragging = true;
          modalHeader.style.cursor = 'move';

          const rect = modalDialog.getBoundingClientRect();
          startX = rect.left;
          startY = rect.top;

          const computedStyle = getComputedStyle(modalDialog);
          const currentWidth = computedStyle.width;
          const currentMaxWidth = computedStyle.maxWidth;
          const currentMinWidth = computedStyle.minWidth;

          modalDialog.classList.remove('modal-dialog-centered');

          modalDialog.style.position = 'fixed';
          modalDialog.style.top = `${startY}px`;
          modalDialog.style.left = `${startX}px`;
          modalDialog.style.margin = '0';
          modalDialog.style.transform = 'none';
          modalDialog.style.transition = 'none';

          if (currentWidth && currentWidth !== 'auto' && currentWidth !== '0px') {
            modalDialog.style.width = currentWidth;
          }
          if (currentMaxWidth && currentMaxWidth !== 'none' && currentMaxWidth !== '0px') {
            modalDialog.style.maxWidth = currentMaxWidth;
          }
          if (currentMinWidth && currentMinWidth !== '0px' && currentMinWidth !== 'auto') {
            modalDialog.style.minWidth = currentMinWidth;
          }

          initialX = e.clientX - startX;
          initialY = e.clientY - startY;
        }
      };

      const drag = (e: MouseEvent) => {
        if (!isDragging) return;
        e.preventDefault();

        const newX = e.clientX - initialX;
        const newY = e.clientY - initialY;

        const rect = modalDialog.getBoundingClientRect();
        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        const constrainedX = Math.max(0, Math.min(newX, maxX));
        const constrainedY = Math.max(0, Math.min(newY, maxY));

        modalDialog.style.left = `${constrainedX}px`;
        modalDialog.style.top = `${constrainedY}px`;
      };

      const dragEnd = () => {
        if (isDragging) {
          isDragging = false;
          modalHeader.style.cursor = 'move';
          modalDialog.style.transition = '';
        }
      };

      modalHeader.style.cursor = 'move';
      modalHeader.style.userSelect = 'none';

      modalHeader.addEventListener('mousedown', dragStart);
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', dragEnd);

      const handleHidden = () => {
        resetPosition();
        modalElement.removeAttribute('data-draggable-setup');
      };

      modalElement.addEventListener('hidden.bs.modal', handleHidden);
    };

    const checkAndSetup = () => {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach((modal) => {
        const modalEl = modal as HTMLElement;
        const h4 = modalEl.querySelector('h4')?.textContent || '';

        if (h4.includes('Confirm Bulk Delete') && !modalEl.hasAttribute('data-draggable-setup')) {
          setTimeout(() => setupModalDraggable(modalEl), 50);
        }
      });
    };

    const interval = setInterval(checkAndSetup, 100);

    return () => {
      clearInterval(interval);
    };
  }, [showBulkDeleteModal]);

  const handleBulkDelete = async () => {
  if (selectedProposals.length === 0) return;
setIsDeleting(true);
  try {
    await deleteProposalsBulk(selectedProposals);
    toast.success("Selected proposals deleted successfully!");
    setSelectedProposals([]);
    refreshProposals();
  } catch (error) {
    console.error("Error during bulk delete:", error);
    toast.error("Failed to delete selected proposals.");
  }
  finally {
      setIsDeleting(false);
    }
};

  const selectedLeadLabel = useMemo(() => {
    if (!selectedLeadId) return null;
    const lead = leads.find((lead) => lead.lead_id === selectedLeadId);
    return lead
      ? {
          value: selectedLeadId,
          label: `${
            leads.find((lead) => lead.lead_id === selectedLeadId)?.contact
              ?.company_name || "Unknown Company"
          } (${
            leads.find((lead) => lead.lead_id === selectedLeadId)?.contact
              ?.contact_person_name || "Unknown Contact"
          })`,
        }
      : null;
  }, [selectedLeadId, leads]);

  const handleItemChange = useCallback(
    (index: number, field: string, value: string | number) => {
      const updatedItems = [...items];
      updatedItems[index] = { ...updatedItems[index], [field]: value };

      if (field === "discount_type") {
        if (value === "percentage") {
          updatedItems[index].discount_amount = 0;
        } else if (value === "amount") {
          updatedItems[index].proposal_discount_percentage = 0;
        }
      }

      let subtotal = 0;
      let totalDiscount = 0;
      let quotedValue = 0;
      let totalCgst = 0;
      let totalSgst = 0;
      let totalIgst = 0;

      updatedItems.forEach((item, idx) => {
        const quantity = Number(item.quantity) || 0;
        const price = Number(item.price) || 0;
        const discountPercent = Number(item.proposal_discount_percentage) || 0;
        const discountAmount = Number(item.discount_amount) || 0;
        const cgstPercent = Number(item.cgst_percentage) || 0;
        const sgstPercent = Number(item.sgst_percentage) || 0;
        const igstPercent = Number(item.igst_percentage) || 0;

        let itemBaseAmount = quantity * price;
        const itemDiscount =
          item.discount_type === "percentage"
            ? itemBaseAmount * (discountPercent / 100)
            : discountAmount;

        let itemQuotedValue = itemBaseAmount - itemDiscount;

        if (index === idx) {
          if (field === "quantity" || field === "price") {
            itemBaseAmount = quantity * price;
            itemQuotedValue = itemBaseAmount - itemDiscount;
            updatedItems[idx].subtotal = itemQuotedValue;
          } else if (field === "subtotal") {
            itemQuotedValue = Number(value) || 0;
            if (quantity > 0) {
              updatedItems[idx].price =
                (itemQuotedValue + itemDiscount) / quantity;
            }
            updatedItems[idx].subtotal = itemQuotedValue;
          } else if (
            field === "proposal_discount_percentage" ||
            field === "discount_amount"
          ) {
            itemQuotedValue = itemBaseAmount - itemDiscount;
            updatedItems[idx].subtotal = itemQuotedValue;
          }
        } else {
          updatedItems[idx].subtotal = itemBaseAmount - itemDiscount;
        }

        const itemCgst = itemQuotedValue * (cgstPercent / 100);
        const itemSgst = itemQuotedValue * (sgstPercent / 100);
        const itemIgst = itemQuotedValue * (igstPercent / 100);

        subtotal += itemBaseAmount;
        totalDiscount += itemDiscount;
        quotedValue += itemQuotedValue;
        totalCgst += itemCgst;
        totalSgst += itemSgst;
        totalIgst += itemIgst;
      });

      const total = quotedValue + totalCgst + totalSgst + totalIgst;

      setFormData((prev) => ({
        ...prev,
        proposal_amount: subtotal,
        proposal_discount: totalDiscount,
        discount_amount:
          updatedItems[0]?.discount_type === "amount"
            ? updatedItems[0]?.discount_amount || 0
            : 0,
        proposal_discount_percentage:
          updatedItems[0]?.discount_type === "percentage"
            ? updatedItems[0]?.proposal_discount_percentage || 0
            : 0,
        sub_total: quotedValue,
        cgst: totalCgst,
        sgst: totalSgst,
        igst: totalIgst,
        proposal_total_amount: total,
        cgst_percentage: updatedItems[0]?.cgst_percentage || 0,
        sgst_percentage: updatedItems[0]?.sgst_percentage || 0,
        igst_percentage: updatedItems[0]?.igst_percentage || 0,
      }));

      setItems(updatedItems);
    },
    [items]
  );

  const handleLeadSelect = useCallback(
    (leadId: string) => {
      setSelectedLeadId(leadId);
      const selectedLead = leads.find((lead) => lead.lead_id === leadId);
      if (selectedLead) {
        const baseAmount =
          (selectedLead.no_logins || 0) * (selectedLead.rate_per_login || 0);
        const quotedValue = baseAmount;
        setFormData({
          ...formData,
          contact_person: selectedLead.contact?.contact_person_name || "",
          Currency: selectedLead.Currency || "",
          product: selectedLead.products?.product_name || "",
          company_name: selectedLead.contact?.company_name || "",
          company_phone: selectedLead.contact?.company_phone || "",
          proposal_no_logins: selectedLead.no_logins || 0,
          proposal_rate_per_login: selectedLead.rate_per_login || 0,
          sub_total: quotedValue,
          lead_owner_name: selectedLead?.contact?.users?.name || "",
          lead_owner_email: selectedLead?.contact?.users?.email || "",
          lead_owner_phone: selectedLead?.contact?.users?.phone_no || "",
          description: defaultDescription,
        });

        setItems([
          {
            item: selectedLead.products?.product_name || "",
            quantity: selectedLead.no_logins || 0,
            price: selectedLead.rate_per_login || 0,
            proposal_discount_percentage: 0,
            discount_amount: 0,
            discount_type: "percentage",
            cgst_percentage: 0,
            sgst_percentage: 0,
            igst_percentage: 0,
            subtotal: quotedValue,
            proposal_amount: baseAmount,
          },
        ]);
      } else {
        setFormData({
          ...formData,
          contact_person: "",
          Currency: "",
          product: "",
          company_name: "",
          company_phone: "",
          proposal_no_logins: 0,
          proposal_rate_per_login: 0,
          sub_total: 0,
          description: defaultDescription,
        });
        setItems([
          {
            item: "",
            quantity: 0,
            price: 0,
            proposal_discount_percentage: 0,
            discount_amount: 0,
            discount_type: "percentage",
            cgst_percentage: 0,
            sgst_percentage: 0,
            igst_percentage: 0,
            subtotal: 0,
            proposal_amount: 0,
          },
        ]);
      }
    },
    [leads, formData, defaultDescription]
  );

  const handleInvoiceClick = useCallback(
    async (proposalId: string) => {
      try {
        const data = await fetchProposalById(proposalId);
        setInvoiceData(data);
        setSelectedProposalId(proposalId);
        setFormData({
          lead_id: data.leads?.lead_id || "",
          contact_person: data.contact_persona_name || "",
          Currency: data.currency || "",
          product: data.product_name || "",
          company_name: data.leads?.contact?.company_name || "",
          company_phone: "",
          signature_name: data.signature_name || "",
          description: data.description || defaultDescription,
          status: data.status || "",
          cgst: data.cgst || 0,
          sgst: data.sgst || 0,
          igst: data.igst || 0,
          proposal_no_logins: data.proposal_no_logins || 0,
          proposal_rate_per_login: data.proposal_rate_per_login || 0,
          proposal_discount: data.proposal_discount || 0,
          discount_amount: data.discount_amount || 0,
          proposal_amount: data.proposal_amount || 0,
          proposal_total_amount: data.proposal_total_amount || 0,
          cgst_percentage: data.cgst_percentage || 0,
          sgst_percentage: data.sgst_percentage || 0,
          igst_percentage: data.igst_percentage || 0,
          proposal_discount_percentage: data.proposal_discount_percentage || 0,
          sub_total: data.sub_total || 0,
          lead_owner_name: data.leads?.contact?.users?.name || "",
          lead_owner_email: data.leads?.contact?.users?.email || "",
          lead_owner_phone: data.leads?.contact?.users?.phone_no || "",
        });

        setSelectedDate(new Date(data.Date_of_proposal));
        setSelectedDate1(new Date(data.validation_date));
        setSelectedLeadId(data.leads?.lead_id || "");

        setItems([
          {
            item: data.product_name || "",
            quantity: data.proposal_no_logins || 0,
            price: data.proposal_rate_per_login || 0,
            proposal_discount_percentage:
              data.proposal_discount_percentage || 0,
            discount_amount: data.discount_amount || 0,
            discount_type: data.discount_amount > 0 ? "amount" : "percentage",
            cgst_percentage: data.cgst_percentage || 0,
            sgst_percentage: data.sgst_percentage || 0,
            igst_percentage: data.igst_percentage || 0,
            subtotal: data.sub_total || 0,
            proposal_amount: data.proposal_amount || 0,
          },
        ]);
      } catch (error) {
        console.error("Failed to fetch proposal", error);
        toast.error("Failed to load proposal data");
      }
    },
    [defaultDescription]
  );
  const resetForm = useCallback(() => {
    setSelectedProposalId(null);
    setFormData({
      lead_id: "",
      contact_person: "",
      Currency: "",
      product: "",
      company_name: "",
      company_phone: "",
      signature_name: "",
      description: defaultDescription,
      status: "",
      cgst: 0,
      sgst: 0,
      igst: 0,
      proposal_no_logins: 1,
      proposal_rate_per_login: 0,
      proposal_discount: 0,
      discount_amount: 0,
      proposal_amount: 0,
      proposal_total_amount: 0,
      cgst_percentage: 0,
      sgst_percentage: 0,
      igst_percentage: 0,
      proposal_discount_percentage: 0,
      sub_total: 0,
      lead_owner_name: "",
      lead_owner_email: "",
      lead_owner_phone: "",
    });
    setSelectedDate(new Date());
    setSelectedDate1(new Date());
    setSelectedLeadId("");
    setItems([
      {
        item: "",
        quantity: 1,
        price: 0,
        proposal_discount_percentage: 0,
        discount_amount: 0,
        discount_type: "percentage",
        cgst_percentage: 0,
        sgst_percentage: 0,
        igst_percentage: 0,
        subtotal: 0,
        proposal_amount: 0,
      },
    ]);
    setSignatureFile(null);
  }, [defaultDescription]);

  const buildProposalPayload = useMemo(
    () => ({
      Date_of_proposal: selectedDate?.toISOString().split("T")[0] || "",
      validation_date: selectedDate1?.toISOString().split("T")[0] || "",
      status: formData.status,
      description: formData.description,
      currency: formData.Currency,
      cgst: formData.cgst,
      sgst: formData.sgst,
      igst: formData.igst,
      cgst_percentage: formData.cgst_percentage,
      sgst_percentage: formData.sgst_percentage,
      igst_percentage: formData.igst_percentage,
      proposal_no_logins: formData.proposal_no_logins,
      proposal_rate_per_login: formData.proposal_rate_per_login,
      proposal_discount: formData.proposal_discount,
      discount_amount: formData.discount_amount,
      proposal_amount: formData.proposal_amount,
      proposal_total_amount: formData.proposal_total_amount,
      proposal_discount_percentage: formData.proposal_discount_percentage,
      sub_total: formData.sub_total,
      lead_id: selectedLeadId,
      signature_name: formData.signature_name,
      attachment: signatureFile,
    }),
    [selectedDate, selectedDate1, formData, selectedLeadId, signatureFile]
  );

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      try {
        if (selectedProposalId) {
          await updateProposal(selectedProposalId, buildProposalPayload);
          resetForm();
        } else {
          await createProposal(buildProposalPayload);
          resetForm();
        }
        await refreshProposals();
      } catch (error) {
        console.error("Error saving proposal", error);
        toast.error("Error saving proposal");
      }
    },
    [selectedProposalId, buildProposalPayload, refreshProposals, resetForm]
  );

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSignatureFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files[0]) {
        setSignatureFile(e.target.files[0]);
      }
    },
    []
  );

  const handleDescriptionChange = useCallback((value: string) => {
    setFormData((prev) => ({ ...prev, description: value }));
  }, []);

  const handleStatusChange = useCallback((selectedOption: any) => {
    setFormData((prev) => ({ ...prev, status: selectedOption.value }));
  }, []);

  const handleDelete = useCallback(async () => {
    if (!selectedProposalId) {
      toast.error("No proposal selected for deletion");
      return;
    }
    setIsDeleting(true);
    try {
      await deleteProposal(selectedProposalId);
      setProposals((prev) =>
        prev.filter((p) => p.proposal_id !== selectedProposalId)
      );
      setSelectedProposalId(null);
    } catch (error) {
      console.error("Failed to delete proposal", error);
    }
    finally {
      setIsDeleting(false);
    }
  }, [selectedProposalId]);

  const handleRemoveItem = useCallback(
    (index: number) => {
      const updatedItems = [...items];
      updatedItems.splice(index, 1);
      setItems(updatedItems);
    },
    [items]
  );

  const [tag1, setTag1] = useState(["Tags"]);
  const [tag2, setTag2] = useState(["Tags"]);
  const activeList1 = useMemo(
    () => [
      { value: "Draft", label: "Draft" },
      { value: "Accepted", label: "Accepted" },
      { value: "Declined", label: "Declined" },
    ],
    []
  );

  const formatDate = useCallback(
    (dateStr: string) =>
      new Date(dateStr).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    []
  );

  // Optimized filteredAndSortedProposals with better filtering logic to avoid unnecessary iterations
  const filteredAndSortedProposals = useMemo(() => {
    let filtered = proposals;
    if (searchText.trim()) {
      filtered = filtered.filter((proposal) => {
        // Flatten proposal main fields
        let fields: string[] = Object.values(proposal).map((val) =>
          val !== null && val !== undefined ? String(val) : ""
        );

        // Add nested fields manually
        fields.push(
          proposal.leads?.contact?.company_name || "",
          proposal.leads?.contact?.contact_person_name || "",
          proposal.leads?.contact?.users?.name || "",
          proposal.leads?.contact?.users?.email || "",
          proposal.leads?.contact?.users?.phone_no || ""
        );

        const searchableString = fields.join(" ").toLowerCase();

        return searchableString.includes(searchText.toLowerCase() || "");
      });
    }
    filtered = filtered.filter((proposal) => {
      if (!proposal.created_at) return true; 
      const createdAt = new Date(proposal.created_at);

      if (
        initialSettings.startDate.getFullYear() === 2000 &&
        dateRange[0].getFullYear() === 2000
      ) {
        return true;
      }

      return createdAt >= dateRange[0] && createdAt <= dateRange[1];
    });

     if (alphaFilter && alphaFilter !== "All") {
    filtered = filtered.filter((proposal) => {
      const name =
        proposal.leads?.contact?.company_name || "";
      return name.toLowerCase().startsWith(alphaFilter.toLowerCase());
    });
  }

  if (alphaFilterproduct && alphaFilterproduct !== "All") {
    filtered = filtered.filter((proposal) => {
      const name =
        proposal.product_name || "";
      return name.toLowerCase().startsWith(alphaFilterproduct.toLowerCase());
    });
  }
   if (alphaFilterleadowner && alphaFilterleadowner !== "All") {
  const letter = alphaFilterleadowner.toLowerCase();
  filtered = filtered.filter((proposal) => {
    const ownerName = (proposal.leads?.contact?.users?.name || "").toLowerCase();
    return ownerName.startsWith(letter);
  });
}

    if (filters.proposal_id) {
      filtered = filtered.filter((p) =>
        (p.proposal_id || "")
          .toLowerCase()
          .includes((filters.proposal_id || "").toLowerCase())
      );
    }
    if (filters.revision_id) {
      filtered = filtered.filter((p) =>
        (p.revision_id || "")
          .toLowerCase()
          .includes((filters.revision_id || "").toLowerCase())
      );
    }
    
    if (filters.contact_name) {
      filtered = filtered.filter((p) =>
        (p.contact_name || "")
          .toLowerCase()
          .includes((filters.contact_name || "").toLowerCase())
      );
    }

    if (filters.product_name) {
      filtered = filtered.filter((p) =>
        (p.product_name || "")
          .toLowerCase()
          .includes((filters.product_name || "").toLowerCase())
      );
    }

    if (filters.client) {
      filtered = filtered.filter(
        (p) =>
          (p.leads?.contact?.company_name || "")
            .toLowerCase()
            .includes((filters.client || "").toLowerCase()) ||
          (p.leads?.contact?.contact_person_name || "")
            .toLowerCase()
            .includes((filters.client || "").toLowerCase())
      );
    }
    // Quoted Value Filter
    if (filters.quoted_min || filters.quoted_max) {
      const min = parseFloat(filters.quoted_min) || 0;
      const max = parseFloat(filters.quoted_max) || Infinity;
      filtered = filtered.filter(
        (p) => (p.sub_total ?? 0) >= min && (p.sub_total ?? 0) <= max
      );
    }
    if (filters.status.length > 0) {
      filtered = filtered.filter(
        (p) => filters.status.includes(p.status) || ""
      );
    }
    if (filters.Date_of_proposal.length > 0) {
      filtered = filtered.filter((p) =>
        filters.Date_of_proposal.includes(formatDate(p.Date_of_proposal) || "")
      );
    }
    if (filters.validation_date.length > 0) {
      filtered = filtered.filter((p) =>
        filters.validation_date.includes(formatDate(p.validation_date) || "")
      );
    }
    if (filters.created_at.length > 0) {
      filtered = filtered.filter((p) =>
        filters.created_at.includes(formatDate(p.created_at) || "")
      );
    }

    // ✅ Lead Owner Funnel Filter (CHECKBOX)
if (filterOwners.length > 0) {
  filtered = filtered.filter((proposal) => {
    const ownerName =
      proposal.leads?.contact?.users?.name ||
      proposal.leads?.contact?.users?.name ||
      "";

    return filterOwners.includes(ownerName);
  });
}


    // Product Funnel Filter
if (filterProducts.length > 0) {
  filtered = filtered.filter(p => filterProducts.includes(p.product_name || ""));
}

// Status Funnel Filter
if (filterStatus.length > 0) {
  filtered = filtered.filter(p => filterStatus.includes(p.status || ""));
}

if (filterQuotationIds.length > 0)   filtered = filtered.filter(p => filterQuotationIds.includes(p.quotaiton_id || ""));
  if (filterRevisionIds.length > 0)    filtered = filtered.filter(p => filterRevisionIds.includes(p.revision_id || ""));
  if (filterContactNames.length > 0)   filtered = filtered.filter(p => filterContactNames.includes(p.contact_persona_name || ""));
  if (filterProductNames.length > 0)   filtered = filtered.filter(p => filterProductNames.includes(p.product_name || ""));
  if (filterClients.length > 0)        filtered = filtered.filter(p => filterClients.includes(p.leads?.contact?.company_name || ""));
  if (filterQuotedValues.length > 0)   filtered = filtered.filter(p => filterQuotedValues.includes(String(p.sub_total)));
  if (filterQuoteStatuses.length > 0)    filtered = filtered.filter(p => filterQuoteStatuses.includes(p.status || ""));
  if (filterQuoteDates.length > 0)     filtered = filtered.filter(p => filterQuoteDates.includes(formatDate(p.Date_of_proposal)));
  if (filterValidationDates.length > 0) filtered = filtered.filter(p => filterValidationDates.includes(formatDate(p.validation_date)));
  if (createdAtFilter.length > 0)      filtered = filtered.filter(p => createdAtFilter.includes(formatDate(p.created_at)));


    const sorted = [...filtered];
    switch (sortOption) {
      case "asc":
        return sorted.sort((a, b) =>
          a.proposal_id.localeCompare(b.proposal_id)
        );
      case "desc":
        return sorted.sort((a, b) =>
          b.proposal_id.localeCompare(a.proposal_id)
        );
      case "recently_viewed":
        return sorted.sort(
          (a, b) =>
            new Date(b.updated_at || b.created_at).getTime() -
            new Date(a.updated_at || a.created_at).getTime()
        );
      case "recently_added":
      default:
        return sorted.sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
    }
  }, [searchText, sortOption, proposals, dateRange, filters,alphaFilter,alphaFilterleadowner,filterProducts,
    filterStatus,
    filterOwners,
    filterQuotationIds,
  filterRevisionIds,
  filterContactNames,
  filterProductNames,
  filterClients,
  filterQuotedValues,
  filterQuoteStatuses,
  filterQuoteDates,
  filterValidationDates,
  createdAtFilter,
    alphaFilterproduct, formatDate]);

  const formatNumber = useCallback(
    (value: number | undefined, currency: string): string => {
      if (value === undefined || value === null) return "0";
      return currency.toUpperCase() === "INR"
        ? Math.round(value).toString()
        : Number(value).toFixed(2);
    },
    []
  );

  const handleDownloadPDF = useCallback(async () => {
    if (!proposalRef.current) return;

    window.scrollTo(0, 0);

    const el = proposalRef.current;
    el.style.width = "830px";
    el.style.minHeight = "1123px";
    el.style.background = "#fff";
    el.style.padding = "4px";

    const elementsToHide = el.querySelectorAll(".no-print");
    elementsToHide.forEach(
      (el) => ((el as HTMLElement).style.display = "none")
    );

    const canvas = await html2canvas(el, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      scrollY: -window.scrollY,
      onclone: (clonedDoc) => {
        clonedDoc.getElementById("view_invoice")?.classList.remove("modal");
      },
    });

    elementsToHide.forEach((el) => ((el as HTMLElement).style.display = ""));

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    const fileName = invoiceData?.quotaiton_id
      ? `Quotation_${invoiceData.quotaiton_id}.pdf`
      : `Quotation_${selectedProposalId || "document"}.pdf`;
    pdf.save(fileName);

    toast.success("PDF downloaded successfully");
  }, [invoiceData, selectedProposalId]);

  const [historyData, setHistoryData] = useState<
    Record<string, ProposalWithHistoryResponse["history"]>
  >({});

  const [columnKeys, setColumnKeys] = useState<string[]>(() => {
    const saved = localStorage.getItem("proposalsColumnKeys");
    if (saved) {
      const parsed = JSON.parse(saved);
    }
    return defaultColumnOrder;
  });

  const { SaveModal } = useColumnOrderSave({
    columnKeys,
    localStorageKey: "proposalsColumnKeys",
    defaultOrder: defaultColumnOrder,
  });



  const fetchHistory = useCallback(
    async (proposalId: string) => {
      // Avoid redundant fetch if already loaded
      if (historyData[proposalId]) return;
      try {
        const data = await fetchProposalWithHistory(proposalId);
        setHistoryData((prev) => ({
          ...prev,
          [proposalId]: data.history,
        }));
      } catch (error) {
        console.error("Failed to fetch history for proposal", error);
        toast.error("Failed to load proposal history");
      }
    },
    [historyData]
  );

  const toggleHistory = useCallback(
    async (proposalId: string) => {
      setExpandedRows((prev) => {
        if (prev.includes(proposalId)) {
          return prev.filter((id) => id !== proposalId);
        } else {
          fetchHistory(proposalId);
          return [...prev, proposalId];
        }
      });
    },
    [fetchHistory]
  );

  const expandedRowRender = useCallback(
    (record: ProposalResponse) => {
      const history = historyData[record.proposal_id] || [];
      if (!history.length) {
        return <p>No history available.</p>;
      }

      return (
        <div className="history-table" style={{ overflowX: "auto" }}>
          <table
            className="table table-bordered"
            style={{ minWidth: "1000px" }}
            role="table"
            aria-label="Proposal History Table"
          >
            <thead>
              <tr>
                <th scope="col">Revision ID</th>
                <th scope="col">Date of Proposal</th>
                <th scope="col">Validation Date</th>
                <th scope="col">Status</th>
                <th scope="col">Quoted Value</th>
                <th scope="col">Total Amount</th>
                <th scope="col">Discount</th>
                <th scope="col">CGST</th>
                <th scope="col">SGST</th>
                <th scope="col">IGST</th>
              </tr>
            </thead>
            <tbody>
              {history.map((item, index) => (
                <tr key={index}>
                  <td>{item.revision_id || "-"}</td>
                  <td>
                    {item.Date_of_proposal
                      ? new Date(item.Date_of_proposal).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>
                  <td>
                    {item.validation_date
                      ? new Date(item.validation_date).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>
                  <td>{item.status || "-"}</td>
                  <td>{formatNumber(item.amount, item.currency)}</td>
                  <td>{formatNumber(item.total_amount, item.currency)}</td>
                  <td>
                    {item.discount > 0
                      ? item.discount_amount > 0
                        ? `₹${formatNumber(
                            item.discount_amount,
                            item.currency
                          )}`
                        : `${
                            item.proposal_discount_percentage
                          }% (₹${formatNumber(item.discount, item.currency)})`
                      : "0"}
                  </td>
                  <td>{formatNumber(item.cgst, item.currency)}</td>
                  <td>{formatNumber(item.sgst, item.currency)}</td>
                  <td>{formatNumber(item.igst, item.currency)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    },
    [historyData, formatNumber]
  );
const uniqueProposalIds = useMemo(
    () =>
      Array.from(new Set(proposals.map((p) => p.proposal_id || ""))).filter(
        (n) => n
      ),
    [proposals]
  );
  const uniqueRevisionIds = useMemo(
    () =>
      Array.from(new Set(proposals.map((p) => p.revision_id || ""))).filter(
        (n) => n
      ),
    [proposals]
  );
  const uniqueClients = useMemo(
    () =>
      Array.from(
        new Set(
          proposals.map(
            (p) =>
              p.leads?.contact?.company_name ||
              p.leads?.contact?.contact_person_name ||
              ""
          )
        )
      ).filter((n) => n),
    [proposals]
  );
  const uniqueProductNames = useMemo(
    () =>
      Array.from(new Set(proposals.map((p) => p.product_name || ""))).filter(
        (n) => n
      ),
    [proposals]
  );
  const uniqueStatuses = useMemo(
    () =>
      Array.from(new Set(proposals.map((p) => p.status || ""))).filter(
        (n) => n
      ),
    [proposals]
  );
  const uniqueProposalDates = useMemo(
    () =>
      Array.from(
        new Set(proposals.map((p) => formatDate(p.Date_of_proposal)))
      ).filter((n) => n),
    [proposals, formatDate]
  );
  const uniqueValidationDates = useMemo(
    () =>
      Array.from(
        new Set(proposals.map((p) => formatDate(p.validation_date)))
      ).filter((n) => n),
    [proposals, formatDate]
  );
  const ownerCounts = useMemo(() => {
    const map: Record<string, number> = {};
    proposals.forEach((p) => {
      const name = p.leads?.contact?.users?.name;
      if (name) map[name] = (map[name] || 0) + 1;
    });
    return map;
  }, [proposals]);
  const uniqueOwners = useMemo(
    () => Object.keys(ownerCounts),
    [ownerCounts]
  );
  const uniqueCreatedAts = useMemo(
    () =>
      Array.from(
        new Set(proposals.map((p) => formatDate(p.created_at)))
      ).filter((n) => n),
    [proposals, formatDate]
  );
  const columnOptions: { label: string; key: ColumnKey }[] = [
    { key: "SI_no", label: "S.No" },
    { key: "quotaiton_id", label: "Quotation ID" },
    { key: "lead_owner", label: "Lead Owner" },
    { key: "revision_id", label: "Revision ID" },
    { key: "contact_name", label: "Client" },
    { key: "proposal_amount", label: "Subtotal" },
    { key: "sub_total", label: "Quoted Value" },
    { key: "cgst", label: "CGST" },
    { key: "sgst", label: "SGST" },
    { key: "igst", label: "IGST" },
    { key: "proposal_total_amount", label: "Total Value" },
    { key: "signature_name", label: "Signature Name" },
    { key: "Date_of_proposal", label: "Date" },
    { key: "validation_date", label: "Open Till" },
    { key: "product_name", label: "Product Name" },
    { key: "created_at", label: "Created Date" },
    { key: "status", label: "Status" },
    { key: "history", label: "History" },
    { key: "action", label: "Action" },
  ];


  // Memoized columns with stable dependencies
  const columns = useMemo(() => {
    const columnMap: Record<ColumnKey, ColumnConfig> = {
      SI_no: {
        title: "S.No",
        key: "SI_no",
        dataIndex: "SI_no",
        fixed: "left",
        render: (_text: any, _record: ProposalResponse, index?: number) =>
          index !== undefined ? (currentPage - 1) * pageSize + index + 1 : "-",
      },
      contact_name: {
        title: (
          <div
            className="flex items-center justify-between"
            style={{ height: 22, whiteSpace: "nowrap" }}
            onClick={(e) => e.stopPropagation()} // ← prevents header sort/expand
          >
            <span className="me-2">Client</span>

            {/* Ant Design Dropdown – pure, tiny, beautiful */}
            <Dropdown
              trigger={["click"]}
              onOpenChange={(open) =>
                open && setTimeout(() => document.body.click(), 0)
              } // optional: close on outside click
              overlay={
                <Menu
                  selectedKeys={alphaFilter ? [alphaFilter] : ["All"]}
                  onClick={({ key }) =>
                    setAlphaFilter(key === "All" ? "" : key)
                  }
                  style={{ width: 50, maxHeight: 250, overflow: "auto" }}
                >
                  <Menu.Item key="All" className="text-center">
                    All
                  </Menu.Item>
                  {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
                    <Menu.Item key={letter} className="text-center">
                      {letter}
                    </Menu.Item>
                  ))}
                </Menu>
              }
            >
              <Button
                size="small"
                type="text"
                onClick={(e) => e.stopPropagation()}
                style={{
                  fontSize: 12,
                  height: 17,
                  padding: "0 8px",
                  border: "1px solid #d9d9d9",
                  background: "#fafafa",
                }}
              >
                {alphaFilter ? alphaFilter.toUpperCase() : "ALL"}
                <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
              </Button>
            </Dropdown>
          </div>
        ),
        key: "contact_name",
        fixed: "left",
        sorter: true,
        render: (_: any, record: ProposalResponse) => {
          const companyName = record.leads?.contact?.company_name || "N/A";
          const contactPerson =
            record.leads?.contact?.contact_person_name || "N/A";
          const initial = companyName.charAt(0).toUpperCase();

          return (
            <div className="d-flex align-items-center justify-content-between gap-2">
              {/* Left side: Avatar + Company/Contact */}
              <div className="d-flex align-items-center gap-2 flex-grow-1">
                <span
                role="button"
                tabIndex={0}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas_edit"
                aria-label={`View ${companyName}`}
                onClick={() => handleInvoiceClick(record.proposal_id)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleInvoiceClick(record.proposal_id);
                  }
                }}
                style={{ display: "inline-block", cursor: "pointer" }}
              >
                <Avatar
                  shape="square"
                  className="btn btn-primary"
                  style={{
                    width: 36,
                    height: 36,
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                >
                  {initial}
                </Avatar>
                </span>
                <div className="d-flex flex-column">
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#view_invoice"
                    onClick={async (e) => {
                      e.preventDefault();
                      setSelectedProposalId(record.proposal_id);
                      await handleInvoiceClick(record.proposal_id);
                      await handleDownloadPDF();
                    }}
                    className="fw-semibold text-dark text-decoration-none"
                  >
                    {highlightMatch(companyName, searchText)}
                  </Link>

                  <span className="text-muted">
                    {highlightMatch(contactPerson, searchText)}
                  </span>
                </div>
              </div>

              {/* Right side: Action icons */}
              <div className="d-flex gap-2">
                {/* Download Button */}
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#view_invoice"
                  onClick={async (e) => {
                    e.preventDefault();
                    setSelectedProposalId(record.proposal_id);
                    await handleInvoiceClick(record.proposal_id);
                    await handleDownloadPDF();
                  }}
                  className="fw-semibold text-dark text-decoration-none"
                >
                  <FaDownload style={{ fontSize: "18px", color: "#d9534f" }} />
                </Link>

                {/* Send Mail Button */}
                {/* <FaEnvelope
                  style={{
                    color: "#007bff",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                  title="Send Proposal Mail"
                  onClick={() => handleSendMail(record.proposal_id)}
                /> */}
              </div>
            </div>
          );
        },
      },
      lead_owner: {
        title: (
    <div
      className="flex items-center justify-between"
      style={{ height: 22, whiteSpace: "nowrap" }}
      onClick={(e) => e.stopPropagation()}   // ← prevents header sort/expand
    >
      <span className="me-2">Lead Owner</span>

      {/* OWNER FILTER (checkbox) */}
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu
                  selectedKeys={filterOwners}
                  style={{ width: 240, maxHeight: 300, overflowY: "auto" }}
                  onClick={(e) => e.domEvent.stopPropagation()}
                >
                  {/* ALL OWNERS */}
                  <Menu.Item
                    key="all"
                    onClick={() => setFilterOwners([])}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <Checkbox checked={filterOwners.length === 0}>
                      All Owners
                    </Checkbox>
                    <span className="text-muted small ms-3">
                      {proposals.length.toLocaleString()}
                    </span>
                  </Menu.Item>

                  <Menu.Divider />

                  {/* INDIVIDUAL OWNERS */}
                  {uniqueOwners.map((owner) => {
                    const isChecked = filterOwners.includes(owner);
                    const count = ownerCounts[owner] ?? 0;

                    return (
                      <Menu.Item
                        key={owner}
                        onClick={() => {
                          setFilterOwners((prev) =>
                            isChecked
                              ? prev.filter((v) => v !== owner)
                              : [...prev, owner]
                          );
                        }}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <Checkbox checked={isChecked}>
                          {owner || "Unknown"}
                        </Checkbox>
                        <span className="text-muted small ms-3">
                          {count.toLocaleString()}
                        </span>
                      </Menu.Item>
                    );
                  })}
                </Menu>
              }
            >
              <Button
                size="small"
                type="text"
                onClick={(e) => e.stopPropagation()}
                className="me-1"
              >
                <FunnelPlotFilled
                  style={{
                    fontSize: 15,
                    color: filterOwners.length > 0 ? "#1890ff" : "#666",
                  }}
                />
                {filterOwners.length > 0 && (
                  <span className="ms-1 small fw-semibold">
                    {filterOwners.length}
                  </span>
                )}
              </Button>
            </Dropdown>
      {/* Ant Design Dropdown – pure, tiny, beautiful */}
      <Dropdown
        trigger={["click"]}
        onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)} // optional: close on outside click
        overlay={
          <Menu
            selectedKeys={alphaFilterleadowner ? [alphaFilterleadowner] : ["All"]}
            onClick={({ key }) => setAlphaFilterleadowner(key === "All" ? "" : key)}
            style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          >
            <Menu.Item key="All" className="text-center">
              All
            </Menu.Item>
            {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
              <Menu.Item key={letter} className="text-center">
                {letter}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button
          size="small"
          type="text"
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 12,
            height: 17,
            padding: "0 8px",
            border: "1px solid #d9d9d9",
            background: "#fafafa",
          }}
        >
          {alphaFilterleadowner ? alphaFilterleadowner.toUpperCase() : "ALL"}
          <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
        </Button>
      </Dropdown>
    </div>
  ),
        dataIndex: "leads",
        key: "lead_owner",
        render: (_: any, record: ProposalResponse) => {
          const user = record.leads?.contact?.users;
          return (
            <div className="d-flex flex-column">
              {/* NAME WITH HOVER CARD */}
              <SubmoduleHoverCard
                name={highlightMatch(user?.name || "N/A", searchText)}
                role="Quotes"
                email={user?.email}
                phone={user?.phone_no}
                contactleadowner_name={user?.name}
                dealowner_name={user?.name}
                leadowner_name={user?.name}
                createdAt={record.created_at}
                variant2={["contactleadOwner", "dealOwner", "leadOwner"]}
              />

              {/* EMAIL + PHONE */}
              <div
                className="text-muted text-truncate"
                style={{ fontSize: "12px", maxWidth: 220 }}
                title={`${user?.email || "N/A"} | ${user?.phone_no || "N/A"}`}
              >
                {user?.email || "N/A"} | {user?.phone_no || "N/A"}
              </div>
            </div>
          );
        },
      },
      quotaiton_id: {
        title: "Quotation ID",
        dataIndex: "quotaiton_id",
        key: "quotaiton_id",
        sorter: true,
        render: (text: string, record: any) => {
          const quotationId = text?.trim() || "N/A";

          return (
            <TextCopy2
              text={quotationId}
              searchQuery={searchText}

              /* TEXT COPY */
              showText={true}        // ✅ text visible
              showIcon={true}       // ❌ no copy icon

              /* DOCUMENT ICON */
              showDocumentIcon={true}
              onDocumentClick={() => {
                handleInvoiceClick(record.proposal_id);
              }}
            />
          );
        },
      },
      revision_id: {
        title: "Revision ID",
        dataIndex: "revision_id",
        key: "revision_id",
        sorter: true,
        render: (text: string) => (
          <TextCopy2
            text={text || "N/A"}
            searchQuery={searchText}
            showRevisionIcon={true}
            showIcon={false}
          />
        ),
      },
      proposal_amount: {
        title: "Subtotal",
        dataIndex: "proposal_amount",
        key: "proposal_amount",
        sorter: true,
        render: (text: string) => highlightMatch(text || "N/A", searchText),
      },
      sub_total: {
        title: "Quoted Value",
        dataIndex: "sub_total",
        key: "sub_total",
        sorter: true,
        render: (text: string) => highlightMatch(text || "N/A", searchText),
      },
      cgst: {
        title: "CGST",
        dataIndex: "cgst",
        key: "cgst",
        sorter: true,
        render: (text: string) => highlightMatch(text || "N/A", searchText),
      },
      sgst: {
        title: "SGST",
        dataIndex: "sgst",
        key: "sgst",
        sorter: true,
        render: (text: string) => highlightMatch(text || "N/A", searchText),
      },
      igst: {
        title: "IGST",
        dataIndex: "igst",
        key: "igst",
        sorter: true,
        render: (text: string) => highlightMatch(text || "N/A", searchText),
      },
      proposal_total_amount: {
        title: "Total Value",
        dataIndex: "proposal_total_amount",
        key: "proposal_total_amount",
        sorter: true,
        render: (text: string) => highlightMatch(text || "N/A", searchText),
      },
      signature_name: {
        title: "Signature Name",
        dataIndex: "signature_name",
        key: "signature_name",
        sorter: true,
        render: (text: string) => (
          <TextCopy2
            text={text?.trim() || "N/A"}
            searchQuery={searchText}
            showPersonIcon={true}      // 👤 signature/person icon
            showText={true}      // show full text
            showIcon={true}      // copy icon
          />
        ),
      },
      Date_of_proposal: {
        title: "Date",
        dataIndex: "Date_of_proposal",
        key: "Date_of_proposal",
        sorter: true,
        render: (text: string) => (
          <TextCopy2
            text={text || "N/A"}
            searchQuery={searchText}
            showDateIcon={true}
            showIcon={false}
          />
        ),
      },
      validation_date: {
        title: "Open Till",
        dataIndex: "validation_date",
        key: "validation_date",
        sorter: true,
        render: (text: string) => (
          <TextCopy2
            text={text || "N/A"}
            searchQuery={searchText}
            showDateIcon={true}
            showIcon={false}
          />
        ),
      },
      product_name: {
        title: (
    <div
      className="flex items-center justify-between"
      style={{ height: 28, whiteSpace: "nowrap" }}
      onClick={(e) => e.stopPropagation()}   // ← prevents header sort/expand
    >
      <span className="me-2">Product Name</span>
      <Dropdown trigger={["click"]} overlay={
        <Menu style={{ width: 220, maxHeight: 300, overflowY: "auto" }} onClick={(e) => e.domEvent.stopPropagation()}>
          <Menu.Item key="all" onClick={(e) => { e.domEvent.stopPropagation(); setFilterProducts([]); }}>
            <Checkbox checked={filterProducts.length === 0}>All Products</Checkbox>
          </Menu.Item>
          {Array.from(new Set(proposals.map(p => p.product_name).filter(Boolean)))
            .sort()
            .map(name => {
              const checked = filterProducts.includes(name);
              return (
                <Menu.Item key={name} onClick={(e) => {
                  e.domEvent.stopPropagation();
                  setFilterProducts(prev => checked ? prev.filter(v => v !== name) : [...prev, name]);
                }}>
                  <Checkbox checked={checked}>{name}</Checkbox>
                </Menu.Item>
              );
            })}
        </Menu>
      }>
        <Button size="small" type="text" style={{ padding: "0 6px" }} onClick={(e) => e.stopPropagation()}>
          <FunnelPlotFilled style={{ fontSize: 15, color: filterProducts.length > 0 ? "#1890ff" : "#000" }} />
        </Button>
      </Dropdown>
      {/* Ant Design Dropdown – pure, tiny, beautiful */}
      <Dropdown
        trigger={["click"]}
        onOpenChange={(open) => open && setTimeout(() => document.body.click(), 0)} // optional: close on outside click
        overlay={
          <Menu
            selectedKeys={alphaFilterproduct ? [alphaFilterproduct] : ["All"]}
            onClick={({ key }) => setAlphaFilterproduct(key === "All" ? "" : key)}
            style={{ width: 50, maxHeight: 250, overflow: "auto" }}
          >
            <Menu.Item key="All" className="text-center">
              All
            </Menu.Item>
            {Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ").map((letter) => (
              <Menu.Item key={letter} className="text-center">
                {letter}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button
          size="small"
          type="text"
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 12,
            height: 17,
            padding: "0 8px",
            border: "1px solid #d9d9d9",
            background: "#fafafa",
          }}
        >
          {alphaFilterproduct ? alphaFilterproduct.toUpperCase() : "ALL"}
          <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
        </Button>
      </Dropdown>
    </div>
  ),
        dataIndex: "product_name",
        key: "product_name",
        sorter: true,
        render: (text: string) => highlightMatch(text || "N/A", searchText),
      },
      created_at: {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        sorter: (a: ProposalResponse, b: ProposalResponse) =>
          new Date(a.created_at || "").getTime() -
          new Date(b.created_at || "").getTime(),
        render: (text: string) => {
          const date = new Date(text);
          if (isNaN(date.getTime())) return "-";

          const dateStr = date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
          const timeStr = date.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          });

          return (
            <div>
              <div>{highlightMatch(dateStr, searchText)}</div>
              <div style={{ fontSize: "12px", color: "#888" }}>
                {highlightMatch(timeStr, searchText)}
              </div>
            </div>
          );
        },
      },
      status: {
        title: (
    <div className="d-flex align-items-center justify-content-between" style={{ height: 22, whiteSpace: "nowrap" }} onClick={(e) => e.stopPropagation()}>
      <span className="me-2">Status</span>

      {/* Funnel Multi-select */}
      <Dropdown trigger={["click"]} overlay={
        <Menu
          selectedKeys={[activeStatusFilter]}
          selectable={true}
          onClick={({ key }) => { // <-- THIS FIXES YOUR ICON COLOR

  if (key === "All") {
    setFilters((prev) => ({ ...prev, status: [] }));
  } else {
    setFilters((prev) => ({ ...prev, status: [key] }));
  }
}}

          style={{ width: 170 }}
        >
          <Menu.Item key="All">
            <BarsOutlined style={{ marginRight: 8, color: "#4000a6ff" }} />
            All
          </Menu.Item>

          <Menu.Item key="Draft">
            <EditOutlined style={{ marginRight: 8, color: "#676dff" }} />
            Draft
          </Menu.Item>

          <Menu.Item key="Accepted">
            <CheckCircleTwoTone twoToneColor="#5cb85c" style={{ marginRight: 8 }} />
            Accepted
          </Menu.Item>

          <Menu.Item key="Declined">
            <CloseCircleTwoTone twoToneColor="#ff2b2b" style={{ marginRight: 8 }} />
            Declined
          </Menu.Item>
        </Menu>
      }>
        <Button size="small" type="text" style={{ padding: "0 6px" }} onClick={(e) => e.stopPropagation()}>
          <FunnelPlotFilled style={{ fontSize: 15, color: filterStatus.length > 0 ? "#1890ff" : "#000" }} />
        </Button>
      </Dropdown>
      </div>
  ),
        dataIndex: "status",
        key: "status",
        sorter: true,
        render: (text: string) => {
          const { icon, className } = {
            Accepted: {
              icon: <i className="ti ti-circle-check me-1" />,
              className: "bg-success",
            },
            Declined: {
              icon: <i className="ti ti-circle-x me-1" />,
              className: "bg-warning",
            },
            Draft: {
              icon: <i className="ti ti-edit-circle me-1" />,
              className: "bg-pending",
            },
          }[text] || {
            icon: <i className="ti ti-alert-circle me-1" />,
            className: "badge-secondary",
          };

          return (
            <AnimatedBadge
              status={text}
              className={className}
              icon={icon.props.className}
            />
          );
        },
      },
      history: {
        title: "",
        key: "history",
        width: 50,
        render: (_: any, record: ProposalResponse) => {
          const isExpanded = expandedRows.includes(record.proposal_id);
          return (
            <button
              className="btn btn-sm btn-icon"
              onClick={() => toggleHistory(record.proposal_id)}
              aria-label={isExpanded ? "Collapse history" : "Expand history"}
              aria-expanded={isExpanded}
            >
              <i className={`ti ti-${isExpanded ? "minus" : "plus"}`} />
            </button>
          );
        },
      },
      action: {
        title: "Action",
        dataIndex: "action",
        key: "action",
        fixed: "right",
        render: (_: any, record: ProposalResponse) => {
          const menu = (
            <Menu
              onClick={(e) => e.domEvent.stopPropagation()}
              style={{
                minWidth: 220,
                borderRadius: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <Menu.Item
                key="edit"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvas_edit"
                onClick={() => {
                  handleInvoiceClick(record.proposal_id);

                }}

                className="d-flex align-items-center"
              >
                <i className="ti ti-edit text-primary me-2 fs-15" />
                <span>Edit Proposal</span>
              </Menu.Item>
              <Menu.Item
                key="delete"
                data-bs-toggle="modal"
                data-bs-target="#delete_proposals"
                onClick={() => setSelectedProposalId(record.proposal_id)}

                className="d-flex align-items-center text-danger"
              >
                <i className="ti ti-trash text-danger me-2 fs-15" />
                <span>Delete Proposal</span>
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item
                key="view"
                data-bs-toggle="modal"
                data-bs-target="#view_invoice"
                onClick={(e) => {
                  e.domEvent.preventDefault();
                  handleInvoiceClick(record.proposal_id);
                }}
                className="d-flex align-items-center"
              >
                <i className="ti ti-eye text-primary me-2 fs-15" />
                <span>View Proposal</span>
              </Menu.Item>
              <Menu.Item
                key="details"
                onClick={() => {
                  setSelectedProposalForModal(record);
                  setIsDetailsOpen(true);
                }}
                className="d-flex align-items-center"
              >
                <i className="ti ti-eye text-success me-2 fs-15" />
                <span>view details</span>
              </Menu.Item>
            </Menu>
          );

          return (
            <Dropdown
              overlay={menu}
              trigger={["click"]}
              placement="bottomRight"
              overlayClassName="table-actions-dropdown"
              onOpenChange={(open) => {
                if (open) {
                  // Prevent row click when dropdown opens
                  setTimeout(() => document.body.click(), 0);
                }
              }}
            >
              <Button
                size="small"
                type="default"
                className="table-action-btn"
                onClick={(e) => e.stopPropagation()}
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Button>
            </Dropdown>
          );
        },
      },
    };
    return columnKeys
  .map((key) => {
    const col = columnMap[key as ColumnKey];
    if (!col) return null;

    return {
      ...col,
      columnKey: key, // 🔥 THIS enables enableColumnDrag
    };
  })
  .filter(
    (col) =>
      col && (col.key === "history" || visibleColumns[col.key as ColumnKey])
  );

  }, [
    currentPage,
    alphaFilter,
    alphaFilterleadowner,
    alphaFilterproduct,
    pageSize,
    searchText,
    handleInvoiceClick,
    handleDownloadPDF,
    visibleColumns,
    expandedRows,
    toggleHistory,
    setSelectedProposalId,
    activeStatusFilter,
    filterProducts,
    filterOwners,
    owner,
    proposals,
    columnKeys
  ]);

  const handleFilterChange = useCallback(
    (
      value: string,
      list: string[],
      setList: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
      if (list.includes(value)) {
        setList(list.filter((item) => item !== value));
      } else {
        setList([...list, value]);
      }
    },
    []
  );

  const handleAccordionToggle = useCallback((sectionId: string) => {
    setOpenAccordion((prev) => (prev === sectionId ? null : sectionId));
  }, []);
  const handleRowOrderChange = (newOrdered: ProposalResponse[]) => {
    setOrderedData(newOrdered);
    // OPTIONAL: persist to backend
    // await reorderLeadSources(newOrdered.map(r => r.LeadSource_id));
  };
  const filteredColumns = useMemo(() => {
  return columns.filter((col: any) => {
    const key = (col.columnKey ?? col.key ?? col.dataIndex) as ColumnKey;
    return visibleColumns[key];
  });
}, [columns, visibleColumns]);


  const wrapText = useCallback((text: string, limit = 20): string => {
    if (!text) return "";
    return text.replace(new RegExp(`(.{${limit}})`, "g"), "$1<wbr>");
  }, []);

  const getStatusCounts = useMemo(() => {
    const counts: Record<string, number> = {};
    proposals.forEach((proposal) => {
      const status = proposal.status?.toLowerCase();
      if (status) {
        counts[status] = (counts[status] || 0) + 1;
      }
    });
    return counts;
  }, [proposals]);

  const statusCounts = getStatusCounts;

  // Memoize status options for filters
  const statusFilterOptions = useMemo(() => statusOptions.sort(), []);

  return (
  <>
    <div>
      <>
        <PageLoadProgressBar />
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="page-header mb-0">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        <i className="ti ti-file-star text-primary me-2" />
                        Quotes
                        <span className="count-title">
                            <CountUp
                              end={proposals.length}
                              duration={3.0}
                              separator=","
                            />
                          </span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Breadcrumb */}
                  <nav aria-label="breadcrumb" className="page-header-breadcrumb mb-3">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link
                          to={userRole === "admin" ? route.dealsDashboard : route.leadsDashboard}
                          style={{
                            color: "#9595b5",
                            textDecoration: "none",
                            transition: "color 0.2s ease"
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.color = "#E41F07"}
                          onMouseLeave={(e) => e.currentTarget.style.color = "#9595b5"}
                        >
                          Dashboard
                        </Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Quotes
                      </li>
                    </ol>
                  </nav>
                  {/* /Breadcrumb */}
                <div className="card">
                  <div className="card-header">
                    <div className="row align-items-center">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                          <div className="icon-form position-relative mb-3 mb-sm-0 ms-3">
                            <span className="form-icon">
                              <i className="ti ti-search" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search Quotes ..."
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                              style={{
                                paddingRight: searchText ? "60px" : "15px",
                              }}
                            />

                            {/* Clear Button - Fixed & Visible */}
                            {searchText && (
                              <button
                                type="button"
                                className="position-absolute end-0 top-50 translate-middle-y me-3 text-muted"
                                style={{
                                  zIndex: 10,
                                  background: "none",
                                  border: "none",
                                  width: "30px",
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => setSearchText("")}
                                aria-label="Clear search"
                              >
                                <i className="ti ti-x fs-16" />
                              </button>
                            )}
                          </div>
                        </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">                                           
<SequentialHighlight>
                              {userRole === "admin" && (
                                <Link
                                  to={route.ProposalInsights}
                                  className="btn btn-outline-warning me-2 mb-0"
                                >
                                  <i className="ti ti-graph me-2" />
                                  Quotes Insights
                                </Link>
                              )}
                            </SequentialHighlight> 
                            <Link
                            to="#"
                            className="btn btn-primary"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvas_add"
                            aria-label="Add New Quotes"
                            style={{
                                position: "relative",
                                overflow: "hidden",
                              }}
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add New Quotes
                            <span
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  background: "linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%)",
                                  transform: "skewX(-20deg) translateX(-150%)",
                                  animation: "shine 3s infinite",
                                }}
                              />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <>
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                          <div className="sort-dropdown drop-down task-drops me-3">
                            <Link
                              to="#"
                              className="dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-label="Filter by Status"
                            >
                              {activeStatusFilter || "All"}
                            </Link>
                            <div className="dropdown-menu dropdown-menu-start">
                              <ul className="list-unstyled mb-0">
                                <li>
                                  <Link
                                    to="#"
                                    onClick={() =>
                                      setFilters((prev) => ({
                                        ...prev,
                                        status: [],
                                      }))
                                    }
                                    className={`dropdown-item d-flex justify-content-between align-items-center ${
                                      filters.status.length === 0
                                        ? "fw-bold text-primary"
                                        : ""
                                    }`}
                                  >
                                    <span>
                                      <i className="ti ti-dots-vertical me-2" />
                                      All Quotes
                                    </span>
                                    <span className="d-flex align-items-center gap-2">
                                      <span className="badge bg-light text-dark">
                                        {proposals.length}
                                      </span>
                                      {filters.status.length === 0 && (
                                        <i className="ti ti-check" />
                                      )}
                                    </span>
                                  </Link>
                                </li>
                                <li>
                                  <hr className="dropdown-divider" />
                                </li>
                                {statusFilterOptions.map((status) => {
                                  const isActive =
                                    filters.status.includes(status);
                                  const count =
                                    statusCounts[status.toLowerCase()] || 0;

                                  return (
                                    <li key={status}>
                                      <Link
                                        to="#"
                                        onClick={() =>
                                          setFilters((prev) => ({
                                            ...prev,
                                            status: [status],
                                          }))
                                        }
                                        className={`dropdown-item d-flex justify-content-between align-items-center ${
                                          isActive ? "fw-bold text-primary" : ""
                                        }`}
                                      >
                                        <span>
                                          <i className="ti ti-dots-vertical me-2" />
                                          {status}
                                        </span>
                                        <span className="d-flex align-items-center gap-2">
                                          <span className="badge bg-light text-dark">
                                            {count}
                                          </span>
                                          {isActive && (
                                            <i className="ti ti-check" />
                                          )}
                                        </span>
                                      </Link>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>

                          <div className="dropdown me-2">
                              <Link
                                to="#"
                                className="dropdown-toggle dropdown-active-toggle common-sort-dropdown-toggle"
                                data-bs-toggle="dropdown"
                              >
                                <i className="ti ti-sort-ascending-2 me-2" />
                                Sort
                              </Link>
                              <div className="dropdown-menu dropdown-menu-start">
                                <ul>
                                  {[
                                    { label: "Ascending", value: "Ascending" },
                                    {
                                      label: "Descending",
                                      value: "Descending",
                                    },
                                    // {
                                    //   label: "Recently Viewed",
                                    //   value: "Recently_viewed",
                                    // },
                                    {
                                      label: "Recently Added",
                                      value: "Recently_added",
                                    },
                                  ].map(({ label, value }) => {
                                    const isActive = sortOption === value;
                                    return (
                                      <li key={label}>
                                        <Link
                                          to="#"
                                          className={`dropdown-item d-flex justify-content-between align-items-center ${isActive
                                            ? "fw-bold text-primary"
                                            : ""
                                            }`}
                                          onClick={() => setSortOption(value)}
                                        >
                                          <span>
                                            <i className="ti ti-circle-chevron-right me-1" />
                                            {label}
                                          </span>
                                          {isActive && (
                                            <i className="ti ti-check" />
                                          )}
                                        </Link>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </div>

                          <div className="icon-form">
                            <span className="form-icon">
                              <i className="ti ti-calendar" />
                            </span>
                            <DateRangePicker
                              initialSettings={initialSettings}
                              onCallback={(start, end) => {
                                setDateRange([start.toDate(), end.toDate()]);
                              }}
                            >
                              <input
                                className="form-control date-range bookingrange"
                                type="text"
                                aria-label="Date Range Picker"
                              />
                            </DateRangePicker>
                          </div>
                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                          {selectedProposals.length > 0 && (
  <button
    className="btn btn-outline-danger me-2 mb-0 d-flex align-items-center"
    onClick={() => setShowBulkDeleteModal(true)}
  >
    <i className="ti ti-trash-x me-2" />
    Bulk Delete ({selectedProposals.length})
  </button>
)}
                          <div className="dropdown me-2">
                              <Link
                                to="#"
                                className="btn bg-soft-purple text-purple"
                                data-bs-toggle="dropdown"
                                data-bs-auto-close="outside"
                              >
                                <i className="ti ti-columns-3 me-2" />
                                Manage Columns
                              </Link>
                              <div className="dropdown-menu dropdown-menu-md-end dropdown-md p-3">
                                <h4 className="mb-2 fw-semibold">
                                  Manage DataTable Columns
                                </h4>
                                <p className="mb-3">
                                  Toggle column visibility to customize your
                                  table view.
                                </p>
                                <div className="border-top pt-3">
                                  <ColumnManagement
                                    columnKeys={columnKeys}
                                    visibleColumns={visibleColumns}
                                    onColumnOrderChange={setColumnKeys}
                                    onColumnToggle={(key) => {
                                      setVisibleColumns((prev) => ({
                                        ...prev,
                                        [key]: !prev[key],
                                      }));
                                    }}
                                    fixedKeys={["action", "contact_name"]}
                                    labels={columnLabels}
                                  />
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-light me-2"
                                    onClick={() =>
                                      setVisibleColumns({
                                        SI_no: true,
                                        quotaiton_id: true,
                                        lead_owner: true,
                                        revision_id: true,
                                        contact_name: true,
                                        proposal_amount: true,
                                        proposal_total_amount: true,
                                        signature_name: true,
                                        Date_of_proposal: true,
                                        validation_date: true,
                                        product_name: true,
                                        created_at: true,
                                        status: true,
                                        action: true,
                                      })
                                    }
                                  >
                                    Reset
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-bs-dismiss="dropdown"
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                            </div>
                          <div className="form-sorts dropdown me-2">
                              <Link
                                to="#"
                                className="dropdown-toggle dropdown-active-toggle common-filter-btn"
                                data-bs-toggle="dropdown"
                                data-bs-auto-close="outside"
                            >
                              <i className="ti ti-filter-share" />
                                Filter
                                {(filterProposalIds.length > 0 ||
                                  filterRevisionIds.length > 0 ||
                                  filterClients.length > 0 ||
                                  filterProductNames.length > 0 ||
                                  filterStatuses.length > 0 ||
                                  filterProposalDates.length > 0 ||
                                  filterValidationDates.length > 0 ||
                                  filterCreatedAts.length > 0) && (
                                    <span className="badge bg-primary rounded-pill ms-2 filter-btn-badge">
                                      {filterProposalIds.length +
                                        filterRevisionIds.length +
                                        filterClients.length +
                                        filterProductNames.length +
                                        filterStatuses.length +
                                        filterProposalDates.length +
                                        filterValidationDates.length +
                                        filterCreatedAts.length}
                                    </span>
                                  )}
                            </Link>
                            <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                              <div className="filter-set-view">
                                <div className="filter-set-head">
                                  <h4>
                                    <i className="ti ti-filter-share" />
                                    Filter
                                  </h4>
                                </div>
                                <div
                                  className="accordion"
                                  id="accordionExample"
                                >
                                  {/* Quotation ID */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "proposalId"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle("proposalId")
                                        }
                                      >
                                        Quotation ID
                                      </Link>
                                      {filterProposalIds.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterProposalIds.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "proposalId" && (
                                      <div
                                        className="filter-set-contents accordion-collapse collapse show"
                                        id="collapseProposalId"
                                      >
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Quotation ID"
                                              value={proposalIdSearch}
                                              onChange={(e) =>
                                                setProposalIdSearch(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          {uniqueProposalIds
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  proposalIdSearch.toLowerCase()
                                                )
                                            )
                                            .map((pid) => (
                                              <li key={pid}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterProposalIds.includes(
                                                        pid
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          pid,
                                                          filterProposalIds,
                                                          setFilterProposalIds
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {pid}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueProposalIds.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                proposalIdSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <hr className="my-2" />
                                  {/* Revision ID */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "revisionId"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle("revisionId")
                                        }
                                      >
                                        Revision ID
                                      </Link>
                                      {filterRevisionIds.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterRevisionIds.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "revisionId" && (
                                      <div className="filter-set-contents accordion-collapse">
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Revision ID"
                                              value={revisionIdSearch}
                                              onChange={(e) =>
                                                setRevisionIdSearch(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          {uniqueRevisionIds
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  revisionIdSearch.toLowerCase()
                                                )
                                            )
                                            .map((rid) => (
                                              <li key={rid}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterRevisionIds.includes(
                                                        rid
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          rid,
                                                          filterRevisionIds,
                                                          setFilterRevisionIds
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {rid}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueRevisionIds.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                revisionIdSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <hr className="my-2" />
                                  {/* Client */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "client"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle("client")
                                        }
                                      >
                                        Client
                                      </Link>
                                      {filterClients.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterClients.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "client" && (
                                      <div className="filter-set-contents accordion-collapse">
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Client"
                                              value={clientSearch}
                                              onChange={(e) =>
                                                setClientSearch(e.target.value)
                                              }
                                            />
                                          </div>
                                          {uniqueClients
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  clientSearch.toLowerCase()
                                                )
                                            )
                                            .map((client) => (
                                              <li key={client}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterClients.includes(
                                                        client
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          client,
                                                          filterClients,
                                                          setFilterClients
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {client}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueClients.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                clientSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  <hr className="my-2" />

                                    {/* Lead Owner */}
                                    <div className="filter-set-content">
                                      <div className="filter-set-content-head d-flex align-items-center gap-2">
                                        <Link
                                          to="#"
                                          className={`filter-accordion-link ${openAccordion === "owner" ? "" : "collapsed"}`}
                                          onClick={() => handleAccordionToggle("owner")}
                                        >
                                          Lead Owner
                                        </Link>

                                        {filterOwners.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterOwners.length}
                                          </span>
                                        )}
                                      </div>

                                      {openAccordion === "owner" && (
                                        <div className="filter-set-contents accordion-collapse">
                                          <div className="filter-content-list">
                                            {/* Search */}
                                            <div className="mb-2 icon-form">
                                              <span className="form-icon">
                                                <i className="ti ti-search" />
                                              </span>
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search Owner"
                                                value={ownerSearch}
                                                onChange={(e) => setOwnerSearch(e.target.value)}
                                              />
                                            </div>

                                            {/* Owners */}
                                            {uniqueOwners
                                              .filter((o) =>
                                                o.toLowerCase().includes(ownerSearch.toLowerCase())
                                              )
                                              .map((owner) => (
                                                <li key={owner}>
                                                  <div className="filter-checks">
                                                    <label className="checkboxs">
                                                      <input
                                                        type="checkbox"
                                                        checked={filterOwners.includes(owner)}
                                                        onChange={() =>
                                                          handleFilterChange(
                                                            owner,
                                                            filterOwners,
                                                            setFilterOwners
                                                          )
                                                        }
                                                      />
                                                      <span className="checkmarks" /> {owner}
                                                    </label>
                                                  </div>
                                                </li>
                                              ))}

                                            {uniqueOwners.filter((o) =>
                                              o.toLowerCase().includes(ownerSearch.toLowerCase())
                                            ).length === 0 && (
                                                <p className="text-muted px-2">No data found</p>
                                              )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  <hr className="my-2" />
                                  {/* Course Name */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "productName"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle("productName")
                                        }
                                      >
                                        Course Name
                                      </Link>
                                      {filterProductNames.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterProductNames.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "productName" && (
                                      <div className="filter-set-contents accordion-collapse">
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Course Name"
                                              value={productNameSearch}
                                              onChange={(e) =>
                                                setProductNameSearch(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          {uniqueProductNames
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  productNameSearch.toLowerCase()
                                                )
                                            )
                                            .map((pname) => (
                                              <li key={pname}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterProductNames.includes(
                                                        pname
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          pname,
                                                          filterProductNames,
                                                          setFilterProductNames
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {pname}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueProductNames.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                productNameSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <hr className="my-2" />
                                  {/* Status */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "status"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle("status")
                                        }
                                      >
                                        Status
                                      </Link>
                                      {filterStatuses.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterStatuses.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "status" && (
                                      <div className="filter-set-contents accordion-collapse">
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Status"
                                              value={statusSearch}
                                              onChange={(e) =>
                                                setStatusSearch(e.target.value)
                                              }
                                            />
                                          </div>
                                          {uniqueStatuses
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  statusSearch.toLowerCase()
                                                )
                                            )
                                            .map((status) => (
                                              <li key={status}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterStatuses.includes(
                                                        status
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          status,
                                                          filterStatuses,
                                                          setFilterStatuses
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {status}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueStatuses.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                statusSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <hr className="my-2" />
                                  {/* Date of Proposal */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "proposalDate"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle("proposalDate")
                                        }
                                      >
                                        Date of Proposal
                                      </Link>
                                      {filterProposalDates.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterProposalDates.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "proposalDate" && (
                                      <div className="filter-set-contents accordion-collapse">
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Date of Proposal"
                                              value={proposalDateSearch}
                                              onChange={(e) =>
                                                setProposalDateSearch(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          {uniqueProposalDates
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  proposalDateSearch.toLowerCase()
                                                )
                                            )
                                            .map((date) => (
                                              <li key={date}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterProposalDates.includes(
                                                        date
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          date,
                                                          filterProposalDates,
                                                          setFilterProposalDates
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {date}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueProposalDates.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                proposalDateSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <hr className="my-2" />
                                  {/* Validation Date */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "validationDate"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle(
                                            "validationDate"
                                          )
                                        }
                                      >
                                        Validation Date
                                      </Link>
                                      {filterValidationDates.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterValidationDates.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "validationDate" && (
                                      <div className="filter-set-contents accordion-collapse">
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Validation Date"
                                              value={validationDateSearch}
                                              onChange={(e) =>
                                                setValidationDateSearch(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          {uniqueValidationDates
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  validationDateSearch.toLowerCase()
                                                )
                                            )
                                            .map((date) => (
                                              <li key={date}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterValidationDates.includes(
                                                        date
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          date,
                                                          filterValidationDates,
                                                          setFilterValidationDates
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {date}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueValidationDates.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                validationDateSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <hr className="my-2" />
                                  {/* Created At */}
                                  <div className="filter-set-content">
                                    <div className="filter-set-content-head d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className={
                                          openAccordion === "createdAt"
                                            ? ""
                                            : "collapsed"
                                        }
                                        onClick={() =>
                                          handleAccordionToggle("createdAt")
                                        }
                                      >
                                        Created At
                                      </Link>
                                      {filterCreatedAts.length > 0 && (
                                          <span className="badge bg-primary rounded-pill small">
                                            {filterCreatedAts.length}
                                          </span>
                                        )}
                                    </div>
                                    {openAccordion === "createdAt" && (
                                      <div className="filter-set-contents accordion-collapse">
                                        <div className="filter-content-list">
                                          <div className="mb-2 icon-form">
                                            <span className="form-icon">
                                              <i className="ti ti-search" />
                                            </span>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Search Created At"
                                              value={createdAtSearch}
                                              onChange={(e) =>
                                                setCreatedAtSearch(
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </div>
                                          {uniqueCreatedAts
                                            .filter((n) =>
                                              n
                                                .toLowerCase()
                                                .includes(
                                                  createdAtSearch.toLowerCase()
                                                )
                                            )
                                            .map((date) => (
                                              <li key={date}>
                                                <div className="filter-checks">
                                                  <label className="checkboxs">
                                                    <input
                                                      type="checkbox"
                                                      checked={filterCreatedAts.includes(
                                                        date
                                                      )}
                                                      onChange={() =>
                                                        handleFilterChange(
                                                          date,
                                                          filterCreatedAts,
                                                          setFilterCreatedAts
                                                        )
                                                      }
                                                    />
                                                    <span className="checkmarks" />{" "}
                                                    {date}
                                                  </label>
                                                </div>
                                              </li>
                                            ))}
                                          {uniqueCreatedAts.filter((n) =>
                                            n
                                              .toLowerCase()
                                              .includes(
                                                createdAtSearch.toLowerCase()
                                              )
                                          ).length === 0 && (
                                            <p className="text-muted px-2">
                                              No data found
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="filter-reset-btns">
                                  <div className="row">
                                    <div className="col-6">
                                      <Link
                                        to="#"
                                        className="btn btn-light w-100"
                                        onClick={() => {
                                          setFilterProposalIds([]);
                                            setFilterRevisionIds([]);
                                            setFilterClients([]);
                                            setFilterProductNames([]);
                                            setFilterStatuses([]);
                                            setFilterProposalDates([]);
                                            setFilterValidationDates([]);
                                            setFilterCreatedAts([]);
                                            setProposalIdSearch("");
                                            setRevisionIdSearch("");
                                            setClientSearch("");
                                            setProductNameSearch("");
                                            setStatusSearch("");
                                            setProposalDateSearch("");
                                            setValidationDateSearch("");
                                            setCreatedAtSearch("");
                                            setFilterOwners([]);
                                            setOwnerSearch("");
                                            setOpenAccordion(null);
                                        }}
                                      >
                                        Reset
                                      </Link>
                                    </div>
                                    <div className="col-6">
                                      <Link
                                        to="#"
                                        className="btn btn-primary"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          // Optionally add toast or close dropdown
                                        }}
                                      >
                                        Filter
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="view-icons">
                            <Link
                              to={route.ProposalsList}
                              className="active"
                              aria-label="List View"
                            >
                              <i className="ti ti-list-tree" />
                            </Link>
                            <Link
                              to={route.ProposalsGrid}
                              aria-label="Grid View"
                            >
                              <i className="ti ti-grid-dots" />
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="active-filters d-flex flex-wrap gap-2 mb-3">
                        {filterProposalIds.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            Proposal IDs:
                            <strong>{filterProposalIds.join(", ")}</strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterProposalIds([])} />
                          </div>
                        )}
                        {filterRevisionIds.length > 0 && (
                          <div className="alert alert-success py-2 mb-2">
                            <strong>
                              Revision IDs: {filterRevisionIds.join(", ")}
                            </strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterRevisionIds([])} />
                          </div>
                        )}
                        {filterClients.length > 0 && (
                          <div className="alert alert-success py-2 mb-2">
                            <strong>Clients: {filterClients.join(", ")}</strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterClients([])} />
                          </div>
                        )}
                        {filterProductNames.length > 0 && (
                          <div className="alert alert-success py-2 mb-2">
                            <strong>
                              {" "}
                              Course Names: {filterProductNames.join(", ")}
                            </strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterProductNames([])} />
                          </div>
                        )}
                        {filterStatuses.length > 0 && (
                          <div className="alert alert-success py-2 mb-2">
                            <strong>
                              {" "}
                              Statuses: {filterStatuses.join(", ")}
                            </strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterStatuses([])} />
                          </div>
                        )}
                        {filterProposalDates.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            <strong>
                              {" "}
                              Proposal Dates: {filterProposalDates.join(", ")}
                            </strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterProposalDates([])} />
                          </div>
                        )}
                        {filterValidationDates.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            <strong>
                              {" "}
                              Validation Dates:{" "}
                              {filterValidationDates.join(", ")}
                            </strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterValidationDates([])} />
                          </div>
                        )}
                        {filterCreatedAts.length > 0 && (
                          <div className="alert alert-info py-2 mb-2">
                            <strong>
                              {" "}
                              Created At: {filterCreatedAts.join(", ")}
                            </strong>
                            <i className="ti ti-x fs-12 cursor-pointer ms-2" onClick={() => setFilterCreatedAts([])} />
                          </div>
                        )}
                        {/* {(filterProposalIds.length ||
                          filterRevisionIds.length ||
                          filterClients.length ||
                          filterProductNames.length ||
                          filterStatuses.length ||
                          filterProposalDates.length ||
                          filterValidationDates.length ||
                          filterCreatedAts.length) > 0 && (
                          <button
                            className="btn btn-sm btn-warning ms-2"
                            onClick={() => {
                              setFilterProposalIds([]);
                              setFilterRevisionIds([]);
                              setFilterClients([]);
                              setFilterProductNames([]);
                              setFilterStatuses([]);
                              setFilterProposalDates([]);
                              setFilterValidationDates([]);
                              setFilterCreatedAts([]);
                            }}
                          >
                            Clear All Filters
                          </button>
                        )} */}
                      </div>
                      <div className="active-filters d-flex flex-wrap gap-2 mb-3">
                        {/* Search Text Badge */}
                        {searchText.trim() && (
                          <span className="alert alert-success py-2 mb-2">
                            Search: {searchText}
                            <i
                              className="ti ti-x ms-1 cursor-pointer"
                              onClick={() => setSearchText("")}
                            />
                          </span>
                        )}

                        {/* Sort Option Badge */}
                        {sortOption !== "recently_added" && (
                          <span className="alert alert-success py-2 mb-2">
                            Sort: {sortOption.replace("_", " ")}
                            <i
                              className="ti ti-x ms-1 cursor-pointer"
                              onClick={() => setSortOption("recently_added")}
                            />
                          </span>
                        )}

                        {/* Status Filter */}
  {filters.status.length > 0 && (
    <span className="alert alert-success py-2 mb-2">
      Status: {filters.status.join(", ")}
      <i
        className="ti ti-x fs-12 ms-1 cursor-pointer"
        onClick={() => setFilters(prev => ({ ...prev, status: [] }))}
      />
    </span>
  )}

  {/* Date Range */}
  {dateRange[0] !== initialSettings.startDate || dateRange[1] !== initialSettings.endDate ? (
    <span className="alert alert-success py-2 mb-2">
      <i className="ti ti-calendar-event" />
      {dateRange[0].toLocaleDateString("en-GB")} – {dateRange[1].toLocaleDateString("en-GB")}
      <i
        className="ti ti-x fs-12 cursor-pointer"
        onClick={() => setDateRange([initialSettings.startDate, initialSettings.endDate])}
      />
    </span>
  ) : null}

                        {/* Quoted Amount Range Badge */}
                        {(filters.quoted_min || filters.quoted_max) && (
                          <span className="alert alert-secondary py-2 mb-2">
                            Quoted: {filters.quoted_min || "0"} -{" "}
                            {filters.quoted_max || "∞"}
                            <i
                              className="ti ti-x ms-1 cursor-pointer"
                              onClick={() => {
                                setFilters((prev) => ({
                                  ...prev,
                                  quoted_min: "",
                                  quoted_max: "",
                                }));
                              }}
                            />
                          </span>
                        )}
                      </div>
                    </>
                   
                    <div className="table-responsive custom-table">
                      <Table
                      rowSelection={{
    type: 'checkbox',
    selectedRowKeys: selectedProposals,
    onChange: (selectedRowKeys) => {
      setSelectedProposals(selectedRowKeys as string[]);
    },
  }}
                        dataSource={filteredAndSortedProposals}
                        columns={filteredColumns}
                        loading={loading}
                        className="custom-table"
                        emptyText="No Quotes found"
                        emptyIcon="ti ti-file-off"
                        enableRowSelection={true}
                        pagination={{
                          current: currentPage,
                          pageSize: pageSize,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50"],
                          onChange: (page: number, size: number) => {
                            setCurrentPage(page);
                            setPageSize(size);
                          },
                        }}
                        recordLabel="Quotes"
                          draggable={true} // <-- ENABLE
                          enableColumnDrag={true}
                        onRowOrderChange={handleRowOrderChange} 
                        onColumnOrderChange={(newCols: any[]) => {
                              const newKeys = newCols
                                .filter((c) => !c.fixed) // Only non-sticky columns
                                .map((c) => c.key ?? c.dataIndex);
                              setColumnKeys(newKeys);
                              // Don't auto-save, let user decide on navigation/refresh
                            }}
                        scroll={{ x: "max-content" }}
                        components={{
                          
                        }}
                        rowKey="proposal_id"
                        expandable={{
                          expandedRowKeys: expandedRows,
                          onExpand: (
                            expanded: boolean,
                            record: ProposalResponse
                          ) => {
                            if (expanded) {
                              toggleHistory(record.proposal_id);
                            } else {
                              setExpandedRows((prev) =>
                                prev.filter((id) => id !== record.proposal_id)
                              );
                            }
                          },
                          expandedRowRender,
                        }}
                      />
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Projects List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
      <>
        {/* Add New Proposal */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_add"
          style={{ minWidth: "1024px" }}
          aria-labelledby="addNewQuotesLabel"
        >
          <div className="offcanvas-header border-bottom">
            <h4 id="addNewQuotesLabel">Add New Quotes</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close Add New Quotes"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form onSubmit={handleSubmit}>
              <h6 className="mt-3 mb-3 border-bottom pb-1">
                <i className="ti ti-file-description me-2 text-primary" />
                Proposal Information
              </h6>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="leadSelect">
                      Leads <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ti ti-users" /> {/* Leads icon */}
                      </span>
                      <div className="flex-grow-1">
                        <Select
                          options={leadsOptions}
                          value={selectedLeadLabel}
                          onChange={(option) => {
                            if (option) handleLeadSelect(option.value);
                          }}
                          className="select"
                          placeholder="Select Lead"
                          classNamePrefix="react-select"
                          inputId="leadSelect"
                          aria-label="Select Lead"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="companyName">
                      Client <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleChange}
                      className="form-control"
                      readOnly
                      aria-label="Client Company Name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="leadOwnerName">
                      Lead Owner Name
                    </label>
                    <input
                      type="text"
                      id="leadOwnerName"
                      className="form-control"
                      value={formData.lead_owner_name || ""}
                      readOnly
                      aria-label="Lead Owner Name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="leadOwnerEmail">
                      Lead Owner Email
                    </label>
                    <input
                      type="email"
                      id="leadOwnerEmail"
                      className="form-control"
                      value={formData.lead_owner_email || ""}
                      readOnly
                      aria-label="Lead Owner Email"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="leadOwnerPhone">
                      Lead Owner Phone
                    </label>
                    <input
                      type="text"
                      id="leadOwnerPhone"
                      className="form-control"
                      value={formData.lead_owner_phone || ""}
                      readOnly
                      aria-label="Lead Owner Phone"
                    />
                  </div>
                </div>
              </div>
              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-calendar me-2 text-primary" />
                Dates & Status
              </h6>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="proposalDate">
                      Date <span className="text-danger">*</span>
                    </label>
                    <div className="icon-form">
                      <span className="form-icon">
                        <i className="ti ti-calendar-event" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker"
                        selected={selectedDate}
                        onChange={setSelectedDate}
                        dateFormat="dd-MM-yyyy"
                        id="proposalDate"
                        aria-label="Proposal Date"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="validationDate">
                      Validation Till <span className="text-danger">*</span>
                    </label>
                    <div className="icon-form">
                      <span className="form-icon">
                        <i className="ti ti-calendar-event" />
                      </span>
                      <DatePicker
                        className="form-control datetimepicker"
                        selected={selectedDate1}
                        onChange={setSelectedDate1}
                        dateFormat="dd-MM-yyyy"
                        id="validationDate"
                        aria-label="Validation Date"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="currency">
                      Currency
                    </label>
                    <input
                      type="text"
                      id="currency"
                      name="Currency"
                      value={formData.Currency}
                      onChange={handleChange}
                      className="form-control"
                      readOnly
                      aria-label="Currency"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="statusSelect">
                      Status <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="ti ti-activity" />{" "}
                        {/* Status/Active icon */}
                      </span>
                      <div className="flex-grow-1">
                        <Select
                          options={activeList1}
                          classNamePrefix="react-select"
                          placeholder="Select"
                          onChange={handleStatusChange}
                          inputId="statusSelect"
                          aria-label="Select Status"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h6 className="mt-4 mb-3 border-bottom pb-1">
                <i className="ti ti-calculator me-2 text-primary" />
                Product & Pricing Summary
              </h6>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="product">
                      Product <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="product"
                      name="product"
                      value={formData.product}
                      onChange={handleChange}
                      className="form-control"
                      readOnly
                      aria-label="Product Name"
                    />
                  </div>
                </div>
                <div className="table-responsive">
                  <table
                    className="table table-view table-sm align-middle"
                    role="table"
                    aria-label="Product Pricing Table"
                  >
                    <thead>
                      <tr>
                        <th scope="col">Product</th>
                        <th scope="col">No. of Logins</th>
                        <th scope="col">Rate per Login</th>
                        <th scope="col">Quoted Value</th>
                        <th scope="col">Discount (% or ₹)</th>
                        <th scope="col">Sub Total</th>
                        <th scope="col">CGST (%)</th>
                        <th scope="col">SGST (%)</th>
                        <th scope="col">IGST (%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <div className="input-table input-table-description">
                              <input
                                type="text"
                                value={item.item}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "item",
                                    e.target.value
                                  )
                                }
                                className="form-control"
                                readOnly
                                aria-label={`Product ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-table">
                              <input
                                type="text"
                                value={item.quantity}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "quantity",
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                                readOnly
                                aria-label={`Quantity ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-table">
                              <input
                                type="text"
                                value={item.price}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "price",
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                                readOnly
                                aria-label={`Price ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-table">
                              <input
                                type="text"
                                value={item.proposal_amount}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "proposal_amount",
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                                min="0"
                                step="0.01"
                                aria-label={`Quoted Value ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-group">
                              <select
                                className="form-select"
                                value={item.discount_type}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "discount_type",
                                    e.target.value
                                  )
                                }
                                aria-label={`Discount Type ${index + 1}`}
                              >
                                <option value="percentage">%</option>
                                <option value="amount">₹</option>
                              </select>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  item.discount_type === "percentage"
                                    ? item.proposal_discount_percentage
                                    : item.discount_amount
                                }
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    item.discount_type === "percentage"
                                      ? "proposal_discount_percentage"
                                      : "discount_amount",
                                    Number(e.target.value)
                                  )
                                }
                                placeholder={
                                  item.discount_type === "amount"
                                    ? "Enter amount in ₹"
                                    : "Enter percentage"
                                }
                                min="0"
                                step="0.01"
                                aria-label={`Discount Amount ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-table">
                              <input
                                type="text"
                                value={item.subtotal}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "subtotal",
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                                min="0"
                                step="0.01"
                                aria-label={`Subtotal ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-table">
                              <input
                                type="text"
                                inputMode="decimal"
                                pattern="[0-9]*"
                                value={item.cgst_percentage}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "cgst_percentage",
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                                aria-label={`CGST Percentage ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-table">
                              <input
                                type="text"
                                inputMode="decimal"
                                pattern="[0-9]*"
                                value={item.sgst_percentage}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "sgst_percentage",
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                                aria-label={`SGST Percentage ${index + 1}`}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="input-table">
                              <input
                                type="text"
                                inputMode="decimal"
                                pattern="[0-9]*"
                                value={item.igst_percentage}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "igst_percentage",
                                    Number(e.target.value)
                                  )
                                }
                                className="form-control"
                                aria-label={`IGST Percentage ${index + 1}`}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="subtotal-div mb-3">
                  <ul className="mb-3">
                    <li>
                      <h5>Quoted Value</h5>
                      <h6>
                        {formatNumber(formData.sub_total, formData.Currency)}
                      </h6>
                    </li>
                    <li>
                      <h5>CGST</h5>
                      <h6>{formatNumber(formData.cgst, formData.Currency)}</h6>
                    </li>
                    <li>
                      <h5>SGST</h5>
                      <h6>{formatNumber(formData.sgst, formData.Currency)}</h6>
                    </li>
                    <li>
                      <h5>IGST</h5>
                      <h6>{formatNumber(formData.igst, formData.Currency)}</h6>
                    </li>
                    <li>
                      <h5>Discount</h5>
                      <h6>
                        {items[0]?.discount_type === "percentage"
                          ? `${formData.proposal_discount_percentage}%`
                          : `₹${formatNumber(
                              formData.discount_amount,
                              formData.Currency
                            )}`}
                        {` (${formatNumber(
                          formData.proposal_discount,
                          formData.Currency
                        )})`}
                      </h6>
                    </li>
                    <li>
                      <h5>Total</h5>
                      <h6>
                        {formatNumber(
                          formData.proposal_total_amount,
                          formData.Currency
                        )}
                      </h6>
                    </li>
                  </ul>
                  <div className="mb-3">
                    <label className="col-form-label" htmlFor="signatureName">
                      Signature Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="signatureName"
                      name="signature_name"
                      value={formData.signature_name}
                      onChange={handleChange}
                      className="form-control"
                      aria-label="Signature Name"
                    />
                  </div>
                </div>
                <h6 className="mt-4 mb-3 border-bottom pb-1">
                  <i className="ti ti-notes me-2 text-primary" />
                  Additional Notes
                </h6>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label
                      className="col-form-label"
                      htmlFor="descriptionEditor"
                    >
                      Description
                    </label>
                    <DefaultEditor
                      value={formData.description}
                      onChange={(e) => handleDescriptionChange(e.target.value)}
                      className="summernote"
                      id="descriptionEditor"
                      aria-label="Description Editor"
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                  onClick={resetForm}
                  aria-label="Cancel Add New Quote"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="offcanvas"
                  aria-label="Create New Quote"
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Add New Proposal */}
        {/* Edit Proposal */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_edit"
          style={{ minWidth: "1024px" }}
          aria-labelledby="editQuotesLabel"
        >
          <div className="offcanvas-header border-bottom">
            <h4 id="editQuotesLabel">Edit Quotes</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close Edit Quotes"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form onSubmit={handleSubmit}>
              <div>
                <h6 className="mt-3 mb-3 border-bottom pb-1">
                  <i className="ti ti-file-description me-2 text-primary" />
                  Proposal Information
                </h6>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label" htmlFor="editLead">
                        Leads <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="editLead"
                        className="form-control"
                        value={
                          leads.find((lead) => lead.lead_id === selectedLeadId)
                            ?.contact?.contact_person_name || ""
                        }
                        readOnly
                        aria-label="Selected Lead"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label
                        className="col-form-label"
                        htmlFor="editCompanyName"
                      >
                        Client <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="editCompanyName"
                        name="company_name"
                        value={formData.company_name}
                        onChange={handleChange}
                        className="form-control"
                        readOnly
                        aria-label="Client Company Name"
                      />
                    </div>
                  </div>
                </div>
                <h6 className="mt-4 mb-3 border-bottom pb-1">
                  <i className="ti ti-calendar me-2 text-primary" />
                  Dates & Status
                </h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label
                        className="col-form-label"
                        htmlFor="editProposalDate"
                      >
                        Date <span className="text-danger">*</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-event" />
                        </span>
                        <DatePicker
                          className="form-control datetimepicker"
                          selected={selectedDate}
                          onChange={setSelectedDate}
                          dateFormat="dd-MM-yyyy"
                          id="editProposalDate"
                          aria-label="Edit Proposal Date"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label
                        className="col-form-label"
                        htmlFor="editValidationDate"
                      >
                        Validation Till <span className="text-danger">*</span>
                      </label>
                      <div className="icon-form">
                        <span className="form-icon">
                          <i className="ti ti-calendar-event" />
                        </span>
                        <DatePicker
                          className="form-control datetimepicker"
                          selected={selectedDate1}
                          onChange={setSelectedDate1}
                          dateFormat="dd-MM-yyyy"
                          id="editValidationDate"
                          aria-label="Edit Validation Date"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="col-form-label" htmlFor="editCurrency">
                        Currency
                      </label>
                      <input
                        type="text"
                        id="editCurrency"
                        name="Currency"
                        value={formData.Currency}
                        onChange={handleChange}
                        className="form-control"
                        readOnly
                        aria-label="Currency"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label
                        className="col-form-label"
                        htmlFor="editStatusSelect"
                      >
                        Status <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ti ti-activity" />{" "}
                          {/* Status/Active icon */}
                        </span>
                        <div className="flex-grow-1">
                          <Select
                            options={activeList1}
                            value={
                              formData.status
                                ? activeList1.find(
                                    (opt) => opt.value === formData.status
                                  )
                                : null
                            }
                            onChange={(option) =>
                              setFormData((prev) => ({
                                ...prev,
                                status: option ? option.value : "",
                              }))
                            }
                            className="select"
                            placeholder="Select"
                            classNamePrefix="react-select"
                            inputId="editStatusSelect"
                            aria-label="Edit Status"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h6 className="mt-4 mb-3 border-bottom pb-1">
                  <i className="ti ti-calculator me-2 text-primary" />
                  Product & Pricing Summary
                </h6>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="col-form-label" htmlFor="editProduct">
                        Product <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="editProduct"
                        name="product"
                        value={formData.product}
                        onChange={handleChange}
                        className="form-control"
                        readOnly
                        aria-label="Product Name"
                      />
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table
                      className="table table-view table-sm align-middle"
                      role="table"
                      aria-label="Edit Product Pricing Table"
                    >
                      <thead>
                        <tr>
                          <th scope="col">Product</th>
                          <th scope="col">No. of Logins</th>
                          <th scope="col">Rate per Login</th>
                          <th scope="col">Quoted Value</th>
                          <th scope="col">Discount (% or ₹)</th>
                          <th scope="col">Sub Total</th>
                          <th scope="col">CGST (%)</th>
                          <th scope="col">SGST (%)</th>
                          <th scope="col">IGST (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <div className="input-table input-table-description">
                                <input
                                  type="text"
                                  value={item.item}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "item",
                                      e.target.value
                                    )
                                  }
                                  className="form-control"
                                  readOnly
                                  aria-label={`Product ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-table">
                                <input
                                  type="text"
                                  value={item.quantity}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "quantity",
                                      Number(e.target.value)
                                    )
                                  }
                                  className="form-control"
                                  readOnly
                                  aria-label={`Quantity ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-table">
                                <input
                                  type="text"
                                  value={item.price}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "price",
                                      Number(e.target.value)
                                    )
                                  }
                                  className="form-control"
                                  readOnly
                                  aria-label={`Price ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-table">
                                <input
                                  type="text"
                                  value={item.proposal_amount}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "proposal_amount",
                                      Number(e.target.value)
                                    )
                                  }
                                  className="form-control"
                                  min="0"
                                  step="0.01"
                                  aria-label={`Quoted Value ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-group">
                                <select
                                  className="form-select"
                                  value={item.discount_type}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "discount_type",
                                      e.target.value
                                    )
                                  }
                                  aria-label={`Discount Type ${index + 1}`}
                                >
                                  <option value="percentage">%</option>
                                  <option value="amount">₹</option>
                                </select>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    item.discount_type === "percentage"
                                      ? item.proposal_discount_percentage
                                      : item.discount_amount
                                  }
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      item.discount_type === "percentage"
                                        ? "proposal_discount_percentage"
                                        : "discount_amount",
                                      Number(e.target.value)
                                    )
                                  }
                                  placeholder={
                                    item.discount_type === "amount"
                                      ? "Enter amount in ₹"
                                      : "Enter percentage"
                                  }
                                  min="0"
                                  step="0.01"
                                  aria-label={`Discount Amount ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-table">
                                <input
                                  type="text"
                                  value={item.subtotal}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "subtotal",
                                      Number(e.target.value)
                                    )
                                  }
                                  className="form-control"
                                  min="0"
                                  step="0.01"
                                  aria-label={`Subtotal ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-table">
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  pattern="[0-9]*"
                                  value={item.cgst_percentage}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "cgst_percentage",
                                      Number(e.target.value)
                                    )
                                  }
                                  className="form-control"
                                  aria-label={`CGST Percentage ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-table">
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  pattern="[0-9]*"
                                  value={item.sgst_percentage}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "sgst_percentage",
                                      Number(e.target.value)
                                    )
                                  }
                                  className="form-control"
                                  aria-label={`SGST Percentage ${index + 1}`}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-table">
                                <input
                                  type="text"
                                  inputMode="decimal"
                                  pattern="[0-9]*"
                                  value={item.igst_percentage}
                                  onChange={(e) =>
                                    handleItemChange(
                                      index,
                                      "igst_percentage",
                                      Number(e.target.value)
                                    )
                                  }
                                  className="form-control"
                                  aria-label={`IGST Percentage ${index + 1}`}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="subtotal-div mb-3">
                    <ul className="mb-3">
                      <li>
                        <h5>Quoted Value</h5>
                        <h6>
                          {formatNumber(formData.sub_total, formData.Currency)}
                        </h6>
                      </li>
                      <li>
                        <h5>CGST</h5>
                        <h6>
                          {formatNumber(formData.cgst, formData.Currency)}
                        </h6>
                      </li>
                      <li>
                        <h5>SGST</h5>
                        <h6>
                          {formatNumber(formData.sgst, formData.Currency)}
                        </h6>
                      </li>
                      <li>
                        <h5>IGST</h5>
                        <h6>
                          {formatNumber(formData.igst, formData.Currency)}
                        </h6>
                      </li>
                      <li>
                        <h5>Discount</h5>
                        <h6>
                          {items[0]?.discount_type === "percentage"
                            ? `${formData.proposal_discount_percentage}%`
                            : `₹${formatNumber(
                                formData.discount_amount,
                                formData.Currency
                              )}`}
                          {` (${formatNumber(
                            formData.proposal_discount,
                            formData.Currency
                          )})`}
                        </h6>
                      </li>
                      <li>
                        <h5>Total</h5>
                        <h6>
                          {formatNumber(
                            formData.proposal_total_amount,
                            formData.Currency
                          )}
                        </h6>
                      </li>
                    </ul>
                    <div className="mb-3">
                      <label
                        className="col-form-label"
                        htmlFor="editSignatureName"
                      >
                        Signature Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="editSignatureName"
                        name="signature_name"
                        value={formData.signature_name}
                        onChange={handleChange}
                        className="form-control"
                        aria-label="Signature Name"
                      />
                    </div>
                  </div>
                  <h6 className="mt-4 mb-3 border-bottom pb-1">
                    <i className="ti ti-notes me-2 text-primary" />
                    Additional Notes
                  </h6>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label
                        className="col-form-label"
                        htmlFor="editDescriptionEditor"
                      >
                        Description
                      </label>
                      <DefaultEditor
                        value={formData.description}
                        onChange={(e) =>
                          handleDescriptionChange(e.target.value)
                        }
                        className="summernote"
                        id="editDescriptionEditor"
                        aria-label="Edit Description"
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    data-bs-dismiss="offcanvas"
                    className="btn btn-light me-2"
                    onClick={resetForm}
                    aria-label="Cancel Edit"
                  >
                    Cancel
                  </button>
                  <div className="d-flex gap-2">
                    {/* Normal update */}
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={async () => {
                        if (!selectedProposalId) return;
                        try {
                          await updateProposal(
                            selectedProposalId,
                            buildProposalPayload
                          );
                          toast.success("Proposal updated successfully");
                          await refreshProposals();
                        } catch (err) {
                          console.error("Update error", err);
                          toast.error("Failed to update proposal");
                        }
                      }}
                      data-bs-dismiss="offcanvas"
                      aria-label="Update Quote"
                    >
                      Update Quotes
                    </button>

                    {/* Revision update */}
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={async () => {
                        if (!selectedProposalId) return;
                        try {
                          await updateProposalRevision(
                            selectedProposalId,
                            buildProposalPayload
                          );
                          toast.success("Revision created & proposal updated");
                          await refreshProposals();
                        } catch (err) {
                          console.error("Revision update error", err);
                          toast.error("Failed to update revision");
                        }
                      }}
                      data-bs-dismiss="offcanvas"
                      aria-label="Update Revision"
                    >
                      Update Revision
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Proposal */}
        {/* Delete Proposals */}
        <ModalDeleteEffect />
          {/* Delete Proposals */}
          <div className="modal fade effect-modal-show" id="delete_proposals" tabIndex={-1} role="dialog" aria-labelledby="deleteProposalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title text-danger fw-bold" id="deleteProposalLabel">
                    <i className="ti ti-alert-triangle me-2" />
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    disabled={isDeleting}
                    onClick={() => {
                      if (!isDeleting) {/* optional: close logic if needed */ }
                    }}
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <div className="modal-body text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
                    <i className="ti ti-trash fs-40 text-danger" />
                  </div>

                  {/* Dynamic proposal name display */}
                  {selectedProposalId &&
                    proposals.find((p) => p.proposal_id === selectedProposalId) && (
                      <h4 className="fw-bold text-dark mb-3">
                        Delete "
                        {proposals.find((p) => p.proposal_id === selectedProposalId)?.leads?.contact?.company_name ||
                          proposals.find((p) => p.proposal_id === selectedProposalId)?.leads?.contact?.contact_person_name ||
                          "this proposal"}
                        "?
                      </h4>
                    )}

                  {!selectedProposalId && (
                    <h4 className="fw-bold text-dark mb-3">Delete This Proposal?</h4>
                  )}

                  <p className="text-muted fs-15 mb-4 px-4">
                    This action <strong>cannot be undone</strong>. The proposal will be
                    <strong> permanently removed</strong> from your system.
                  </p>

                  <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                    <i className="ti ti-info-circle me-2" />
                    <strong>Warning:</strong> All associated data (notes, details, revisions) will also be deleted.
                  </div>

                  <div className="d-flex gap-3 justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn btn-light px-5 py-2 fw-medium"
                      data-bs-dismiss="modal"
                      disabled={isDeleting}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger px-5 py-2 fw-medium"
                      onClick={handleDelete}
                      data-bs-dismiss="modal"
                      disabled={isDeleting}
                    >
                      {isDeleting ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />
                          Deleting...
                        </>
                      ) : (
                        <>
                          <i className="ti ti-trash me-2" />
                          Yes, Delete It
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalDeleteEffect />
        {/* /Delete Proposals */}
        <Modal
            show={showBulkDeleteModal}
            onHide={() => {
              if (!isDeleting) setShowBulkDeleteModal(false);
            }}
            centered
            backdrop="static"
            className="effect-modal-show"
          >
            <div className="modal-header">
              <h5 className="modal-title text-danger fw-bold" id="bulkDeleteProposalsLabel">
                <i className="ti ti-alert-triangle me-2" />
                Confirm Bulk Deletion
              </h5>
              <button
                className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
                aria-label="Close"
                onClick={() => {
                  if (!isDeleting) setShowBulkDeleteModal(false);
                }}
                disabled={isDeleting}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body text-center">
              <div className="avatar avatar-xl bg-danger-light rounded-circle mb-4 mx-auto effect-avatar-pulse">
                <i className="ti ti-trash fs-40 text-danger" />
              </div>
              <h4 className="fw-bold text-dark mb-3">
                Delete {selectedProposals.length} Proposal{selectedProposals.length > 1 ? "s" : ""}?
              </h4>
              <p className="text-muted fs-15 mb-4 px-4">
                This action <strong>cannot be undone</strong>.
                The selected proposals will be
                <strong> permanently removed</strong> from
                your system.
              </p>
              <div className="alert alert-warning py-3 mx-4 mb-4 rounded-3 border-warning">
                <i className="ti ti-info-circle me-2" />
                <strong>Warning:</strong> This may affect
                related records, notes, and quotation data.
              </div>
              <div className="d-flex gap-3 justify-content-center mt-4">
                <button
                  type="button"
                  className="btn btn-light px-5 py-2 fw-medium"
                  onClick={() => setShowBulkDeleteModal(false)}
                  disabled={isDeleting}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger px-5 py-2 fw-medium"
                  onClick={async () => {
                    await handleBulkDelete();
                    setShowBulkDeleteModal(false);
                  }}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-trash me-2" />
                      Yes, Delete Permanently
                    </>
                  )}
                </button>
              </div>
            </div>
          </Modal>
        {/* Proposal Model */}
        <div className="modal-body p-5" ref={proposalRef}>
          <div className="modal fade" id="view_invoice" tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-body p-5 a4-sheet">
                  {loading && <p>Loading Quotation...</p>}
                  {!loading && invoiceData && (
                    <>
                      {/* Header Section */}
                      <div className="row mb-4 header-section align-items-center">
                        <div className="col-md-6 d-flex flex-column justify-content-center">
                          <div className="mb-3">
                            <img
                              src="assets/img/favicon.png"
                              alt="Company Logo"
                              crossOrigin="anonymous"
                              className="img-fluid"
                              style={{ width: "50%", height: "75%" }}
                            />
                          </div>
                          <div>
                            <h3 className="fw-bold mb-1">
                              EROYAL TECH SYSTEMS PRIVATE LIMITED
                            </h3>
                            <p className="mb-1 small">
                              No.5/41, 5th Cross St, Balaji Nagar,
                              Ekkatuthangal,
                            </p>
                            <p className="mb-1 small">
                              Chennai, TamilNadu - 600032.
                            </p>
                            <p className="mb-1 small">
                              {invoiceData?.leads?.contact?.users?.name ||
                                "Selva"}
                            </p>
                            <p className="mb-1 small">
                              {invoiceData?.leads?.contact?.users?.phone_no ||
                                "8056069701"}
                            </p>
                            <p className="mb-1 small">
                              e-Mail ID:{" "}
                              {invoiceData?.leads?.contact?.users?.email ||
                                "selva@royaltechsystems.co.in"}
                            </p>
                            <p className="mb-1 small">
                              Website: royaltechsystems.co.in
                            </p>
                          </div>
                        </div>
                        <div
                          className="col-md-6 text-end"
                          style={{ marginTop: "110px" }}
                        >
                          <div className="quote-box">
                            <h2 className="fw-bold mb-2">
                              {invoiceData?.revision_id
                                ? "Revised Quote"
                                : "Quote"}
                            </h2>

                            <div className="quote-details text-start">
                              <div className="d-flex justify-content-between mb-1">
                                <span className="fw-medium">DATE</span>
                                <span>
                                  {new Date(
                                    invoiceData.Date_of_proposal
                                  ).toLocaleDateString("en-GB")}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between mb-1">
                                <span className="fw-medium">DUE DATE</span>
                                <span>
                                  {new Date(
                                    invoiceData.validation_date
                                  ).toLocaleDateString("en-GB")}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span className="fw-medium">QUOTE NO</span>
                                <span>
                                  {invoiceData.quotaiton_id}/
                                  {invoiceData.revision_id}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Bill To Section */}
                      <div className="mb-4">
                        <div className="bill-to-header">BILL TO</div>
                        <div className="bill-to-content">
                          <div className="row">
                            {/* Left: Company Info */}
                            <div className="col-md-6">
                              {invoiceData.leads?.contact?.company_name && (
                                <p className="mb-1">
                                  <strong>Company Name:</strong>{" "}
                                  {invoiceData.leads.contact.company_name}
                                </p>
                              )}
                              {invoiceData.leads?.contact
                                ?.contact_person_name && (
                                <p className="mb-1">
                                  <strong>Contact Person Name:</strong>{" "}
                                  {
                                    invoiceData.leads.contact
                                      .contact_person_name
                                  }
                                </p>
                              )}
                              {invoiceData.leads?.contact?.company_mail && (
                                <p className="mb-1">
                                  <strong>E-Mail ID:</strong>{" "}
                                  {invoiceData.leads.contact.company_mail}
                                </p>
                              )}
                            </div>

                            {/* Right: Branch Info */}
                            <div className="col-md-6">
                              {invoiceData?.address?.[0]?.branch_address && (
                                <p className="mb-1">
                                  <strong>Branch Address:</strong>{" "}
                                  {invoiceData.address[0].branch_address}
                                </p>
                              )}
                              {invoiceData?.address?.[0]?.branch_city && (
                                <p className="mb-1">
                                  <strong>City:</strong>{" "}
                                  {invoiceData.address[0].branch_city}
                                </p>
                              )}
                              {invoiceData?.address?.[0]?.branch_state && (
                                <p className="mb-1">
                                  <strong>State:</strong>{" "}
                                  {invoiceData.address[0].branch_state}
                                </p>
                              )}
                              {invoiceData?.address?.[0]?.branch_zipcode && (
                                <p className="mb-1">
                                  <strong>Zipcode:</strong>{" "}
                                  {invoiceData.address[0].branch_zipcode}
                                </p>
                              )}
                              {invoiceData?.address?.[0]?.branch_country && (
                                <p className="mb-1">
                                  <strong>Country:</strong>{" "}
                                  {invoiceData.address[0].branch_country}
                                </p>
                              )}
                              {invoiceData?.address?.[0]?.gst_number && (
                                <p className="mb-1">
                                  <strong>GST Number:</strong>{" "}
                                  {invoiceData.address[0].gst_number}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Services Table */}
                      <table
                        className="table table-bordered mb-4"
                        role="table"
                        aria-label="Quotation Details Table"
                      >
                        <thead>
                          <tr>
                            <th scope="col">DESCRIPTION</th>
                            <th scope="col" className="text-end">
                              QTY
                            </th>
                            <th scope="col" className="text-end">
                              PRODUCT RATE{" "}
                            </th>
                            <th scope="col" className="text-end">
                              DISCOUNT
                            </th>
                            <th scope="col" className="text-end">
                              QUOTED VALUE
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                              }}
                            >
                              <strong>
                                {invoiceData.product_name
                                  .split(" - ")
                                  .map((part, index) => (
                                    <React.Fragment key={index}>
                                      {part}
                                      {index === 0 && " -"}
                                      {index <
                                        invoiceData.product_name.split(" - ")
                                          .length -
                                          1 && <br />}
                                    </React.Fragment>
                                  ))}
                              </strong>
                              <br />
                              <small>
                                Total No {invoiceData.proposal_no_logins} Logins
                              </small>
                            </td>
                            <td className="text-end">
                              {invoiceData.proposal_no_logins}
                            </td>
                            <td className="text-end">
                              {formatNumber(
                                invoiceData.proposal_amount,
                                invoiceData.currency
                              )}
                            </td>

                            <td className="text-end">
                              {invoiceData.proposal_discount > 0
                                ? invoiceData.discount_amount > 0
                                  ? `₹${formatNumber(
                                      invoiceData.discount_amount,
                                      invoiceData.currency
                                    )}`
                                  : `${
                                      invoiceData.proposal_discount_percentage
                                    }% (₹${formatNumber(
                                      invoiceData.proposal_discount,
                                      invoiceData.currency
                                    )})`
                                : "0"}
                            </td>
                            <td className="text-end">
                              {formatNumber(
                                invoiceData.sub_total,
                                invoiceData.currency
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={4} className="text-end fw-bold">
                              {invoiceData.cgst > 0 && (
                                <>
                                  <br />
                                  CGST {invoiceData.cgst_percentage}%
                                </>
                              )}
                              {invoiceData.sgst > 0 && (
                                <>
                                  <br />
                                  SGST {invoiceData.sgst_percentage}%
                                </>
                              )}
                              {invoiceData.igst > 0 && (
                                <>
                                  <br />
                                  IGST {invoiceData.igst_percentage}%
                                </>
                              )}
                              <br />
                              Total Amount
                            </td>
                            <td className="text-end">
                              {invoiceData.cgst > 0 && (
                                <>
                                  <br />
                                  {formatNumber(
                                    invoiceData.cgst,
                                    invoiceData.currency
                                  )}
                                </>
                              )}
                              {invoiceData.sgst > 0 && (
                                <>
                                  <br />
                                  {formatNumber(
                                    invoiceData.sgst,
                                    invoiceData.currency
                                  )}
                                </>
                              )}
                              {invoiceData.igst > 0 && (
                                <>
                                  <br />
                                  {formatNumber(
                                    invoiceData.igst,
                                    invoiceData.currency
                                  )}
                                </>
                              )}
                              <br />
                              <strong>
                                {formatNumber(
                                  invoiceData.proposal_total_amount,
                                  invoiceData.currency
                                )}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Terms & Conditions */}
                      <div className="mb-4">
                        <div className="terms-header">Terms & Conditions:</div>
                        <div className="terms-content">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-2">
                                <strong>Description:</strong>
                                <div className="ms-1">
                                  {invoiceData?.description?.trim() ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: invoiceData.description,
                                      }}
                                    />
                                  ) : (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: defaultDescription,
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <p className="mb-2">
                                <strong>For Online Payment :</strong>
                              </p>
                              <p className="mb-1">
                                <strong>A/c Name :</strong> EROYAL TECH SYSTEMS
                                PRIVATE LIMITED
                              </p>
                              <p className="mb-1">
                                <strong>Bank Name :</strong> Axis Bank
                              </p>
                              <p className="mb-1">
                                <strong>A/c No :</strong> 921020017148861
                              </p>
                              <p className="mb-1">
                                <strong>Branch :</strong> Kattupakkam, Chennai
                              </p>
                              <p className="mb-1">
                                <strong>IFSC Code :</strong> UTIB0002958
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Footer Contact */}
                      <div className="text-center mb-3 footer-contact">
                        <p className="mb-2">
                          If you have any questions about this price quote,
                          please contact
                        </p>
                        <p className="mb-3">
                          <strong>
                            [Name:{" "}
                            {invoiceData?.leads?.contact?.users?.name ||
                              "Selva"}
                            , Mobile:{" "}
                            {invoiceData?.leads?.contact?.users?.phone_no ||
                              "8056069701"}
                            , E-mail:{" "}
                            {invoiceData?.leads?.contact?.users?.email ||
                              "selva@royaltechsystems.co.in"}
                            ]
                          </strong>
                        </p>
                        <p className="fw-bold thank-you">
                          Thank You For Your Business!
                        </p>
                      </div>
                    </>
                  )}
                  {!loading && !invoiceData && <p>No Quotation selected.</p>}
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-primary no-print"
                      onClick={handleDownloadPDF}
                      aria-label="Download Quotation as PDF"
                    >
                      <i className="ti ti-download me-1"></i> Download Quotation
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Proposal Model */}
      </>
    </div>
    <ProposalDetailsModal
        isOpen={isDetailsOpen}
        onClose={() => setIsDetailsOpen(false)}
        proposal={selectedProposalForModal}
      />
      {/* Save Column Order Modal */}
      <SaveModal />
      <ScrollToTop />
  </>
  );
};
export default Proposalslist;
